import {
  getAllDriver,
  getAllRoutes,
  getAllSupplier,
  getAllVehicleNumber,
  getDashbordData,
  getLastTrip,
  getStatesData,
  handleKeyDown,
} from "_services";
import { getCityLocationList } from "_services/accountsServices/cityLocationService";
import { getConsignorListData } from "_services/accountsServices/consignorServices";
import {
  getDataLrDetails,
  getLorryTypeList,
} from "_services/accountsServices/lrServices";
import { getBranchDropdownListData } from "_services/dropdownServices/dropdownService";
import {
  CityDropdownForTrip,
  CommonDatePicker,
  CommonInput,
  CustomSelect,
  Heading,
  MapInput,
  VehicleDropdownForTrip,
} from "components";
import SingleSelectDropdownInfinite from "components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite";

import { Images } from "constants";
import images from "constants/images";
import { UserContext } from "context";
import { State } from "country-state-city";
import { addEwayWill, addTrip, getlorryType } from "features";
import { errorSchema, utils } from "helper";
import { produce } from "immer";
import {
  AddEditLrModal,
  AddEditMarketDriver,
  AddEditOwnDriver,
  AddEditVehicleModal,
  AddLocationModal,
  AddLrModal,
  AddRouteModal,
  ConfirmModalFor,
  EndTripModal,
  LrDetailModal,
  LrFreightModal,
  MakeTruckAvailableModal,
  SelectLrModal,
  VehicleTypeModal,
} from "modals";
import AddEditConsignor from "modals/AddEditConsignor/AddEditConsignor";
import AddEditSupplier from "modals/AddEditSupplier";
import moment from "moment";
import Loading from "pages/Loading";
import React, { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import LoadingChalli from "./LoadingChalli";


const CreatTrip = () => {
  const {
    masterData,
    cities,
    lrDetialsFrom,
    setLrDetialsFrom,
    dispatchIndent,
    setDispatchIndent
  } = useContext(UserContext);
  const location = useLocation();
  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  // let startdate = new Date();
  // let enddate = addDays(startdate, 2);

  const intialForm = {
    company_id: StorageService.getCompanyId(),
    branch_id: "",
    dispatch_date: new Date(),
    driver_id: "",
    supplier_id: "",
    vehicle_type_id: "",
    lorry_type_id: "",
    vehicle_id: "",
    start_kms: "",
    end_kms: 0,
    route_name: "",
    from_location: [],
    to_location: [],
    freight_type: 4,
    total_Freight: ""
  };

  const initiFrom = {
    from_city: "",
    from_state: "",
    lat: "",
    long: "",
  };

  const initiTo = {
    to_city: "",
    to_state: "",
    lat: "",
    long: "",
  };

  const ewayinit = {
    eway_bill_number: "",
    start_date: new Date(),
    end_date: new Date(),
  };

  const intialTotal = {
    freight_type: 6,
    qty: "",
    rate: "",
    amount: "",
    tds_diduction: 0,
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formValue, setFormValue] = useState(intialForm);
  const {
    loading: ewayLoading,
    error,
    data,
  } = useSelector((state) => state.trip);
  const [ewayForm, setEwayForm] = useState(ewayinit);
  const [formLabelValue, setFormLabelValue] = useState(intialForm);
  const [formError, setFormError] = useState("");
  const [show, setShow] = useState(false);
  const [vehicleTypeshow, setVehicleTypeShow] = useState(false);
  const [showCreatRoute, setShowCreatRoute] = useState(false);
  const [showSelectLr, setShowSelectLr] = useState(false);
  const [fromLoction, setFromLoction] = useState([initiFrom]);
  const [toLoction, setToLoction] = useState([initiTo]);
  const [fromlocationValue, setFromLocatonValue] = useState([""]);
  const [tolocationValue, setToLocatonValue] = useState([""]);
  const [divCount, setDivCount] = useState(1);
  const [tripTable, setTripTable] = useState([]);
  const [listOfLr, setListOfLr] = useState([{ list: [] }]);
  const [indexofTable, setIndexofTable] = useState(0);
  const [branchList, setBranchList] = useState([]);
  const [consignorList, setConsignorList] = useState([]);
  const [routeList, setRouteList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [vehicleNumbList, setVehicleNumbList] = useState([]);
  const [hasMoreVehicle, setHasMoreVehicle] = useState(true);
  const [page, setPage] = useState(1);
  const [ownerShip, setOwnerShip] = useState("");
  const [callbackDataRoute, setcallbackDataRoute] = useState();
  const [vehicleTypeLabel, setVehicleTypeLabel] = useState({
    label: "",
    value: "",
  });
  const [selectedLr, setSelectedLr] = useState([{ list: [] }]);
  const [allFrightLr, setAllFrightLr] = useState([]);
  const [separateLr, setSeprateLr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [ewaybillShow, setEwaybillShow] = useState(false);
  const [ewayBillId, setEwayBillId] = useState("");
  const [LrDetele, setLrDetele] = useState({
    item: "",
    outerIndex: "",
    innerIndex: "",
    title: "",
  });
  const [lorryType, setLorryType] = useState([]);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showOffcanvasSupplier, setShowOffcanvasSupplier] = useState(false);
  const [showOffcanvasDriver, setShowOffcanvasDriver] = useState(false);
  const [showOffcanvasMarketDriver, setShowOffcanvasMarketDriver] = useState(false);
  const [showLrDetail, setShowLrDetail] = useState(false);
  const [showAddLR, setShowAddLR] = useState(false);
  const [selectParty, setSelectParty] = useState(false);
  const [showPrefield, setShowingPrefield] = useState(false);
  const [isAddConsignor, setIsAddConsignor] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [showEndTrip, setShowEndTrip] = useState(false);
  const [showAvailableTruck, setShowAvailableTruck] = useState(false);
  const [lastTripDetails, setLastTripDetails] = useState();
  const [lastReading, setLastReading] = useState("");
  const [vehicleStatus, setVehicleStatus] = useState();
  const hiddenInputRef = useRef(null);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showWithOutLrModal, setShowWithOutLrModal] = useState(false);
  const [searchValue, setSearchValue] = useState("")
  const [listOfFreight, setListOfFreight] = useState([]);
  const [isSupplier, setIsSupplier] = useState(false);
  const [isDriver, setIsDriver] = useState(false);
  const [showOffcanvasOfSupplier, setShowOffcanvasOfSupplier] = useState(false);
  const [showOffcanvasOfDriver, setShowOffcanvasOfDriver] = useState(false);
  const [formTotal, setFormTotal] = useState(intialTotal);
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [tdsList, setTDsList] = useState([]);
  const [openLoction, setOpenLoction] = useState(false)
  const [typeOfDropdown, setTypeOfDropdown] = useState({
    type: "",
    index1: '',
    index: ""
  })
  const [newListOfLr, setNewListOfLr] = useState([{ list: [] }])
  const [refreshVehicleDropdown, setRefreshVehicleDropdown] = useState(0);
  const [challiValues, setChalliValues] = useState([]);
  const [createTripBtn, setCreateTripBtn] = useState(false)

  const branchView = formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight?.view == 1
  useEffect(() => {
    if (masterData) {
      const Tds = masterData.tds_section_list?.map((item) => {
        return { label: item?.name, value: item?.id };
      });
      const lrFreight = masterData?.contract_rate_type_list?.map((item) => {
        return { label: item?.name, value: item?.id };
      });
      setTDsList([{ label: "No Deduction", value: 0 }, ...Tds]);
      setFreightTypeList(lrFreight);
      setFormTotal({ ...formTotal });
    }
  }, [masterData]);

  useEffect(() => {
    if (formTotal?.freight_type !== 6) {
      setFormTotal((prev) => {
        let total = Number(prev?.qty) * Number(prev?.rate) == 0 ? "" : Number(prev?.qty) * Number(prev?.rate)
        return ({
          ...prev,
          amount: total,
        })
      }

      );
    }
  }, [formTotal.rate, formTotal.qty]);

  useEffect(() => {
    setFormTotal((prev) => ({
      ...prev,
      rate: prev.freight_type === 6 ? 0 : prev.rate || '',
      qty: prev.freight_type === 6 ? 0 : prev.qty || '',

    }));
  }, [formTotal.freight_type]);

  useEffect(() => {
    if (formLabelValue.branch_id) {

      setFormValue((pre) => {
        return {
          ...pre,
          dispatch_date: formLabelValue?.branch_id?.dispatch_date_time == 0 ? new Date() : new Date()
        }
      })
    }

  }, [formLabelValue.branch_id]);



  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      setShowBackModal(true);
      window.history.pushState({ modalOpened: false }, "");
    };

    window.addEventListener("popstate", handlePopState);
    window.history.pushState({ modalOpened: false }, "");

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const submitLeaveModalProps = () => {
    navigate("/trip/addtrip");
  };

  const withoutLrSubmit = () => {
    onSubmit()
  };


  const backModalProps = {
    show: showBackModal,
    closeModal: (e) => setShowBackModal(false),
    title: "Leave This Page",
    submitTitle: "Confirm",
    onSubmit: submitLeaveModalProps,
    confirmModal: "confirmModal",
  };

  const withoutLrModalProps = {
    show: showWithOutLrModal,
    closeModal: (e) => setShowWithOutLrModal(false),
    title: "Without LR confirmation",
    submitTitle: "Confirm",
    onSubmit: withoutLrSubmit,
    confirmModal: "confirmModal",
    isLoadding: loading,
    disabled: loading
  };



  useEffect(() => {
    fetchInitialData();
    // fetchVehicleList();
  }, []);

  useEffect(() => {
    if (callbackDataRoute) {

      callbackDataRoute?.from_location?.map((user) => addFromInput());
      callbackDataRoute?.to_location?.map((user) => {
        setToLoction([...toLoction, initiTo]);
        setToLocatonValue([...tolocationValue, ""]);
        setListOfLr([...listOfLr, { list: [] }]);
        setSelectedLr([...selectedLr, { list: [] }]);
        setDivCount(callbackDataRoute?.to_location.length);
      });

      setFromLocatonValue(
        callbackDataRoute?.from_location?.map((user) => ({
          label: `${user.from_city}, ${user?.from_state}`,
          value: `${user.from_city}, ${user?.from_state}`,
          name: `${user.from_city}, ${user?.from_state}`,
          _id: `${user.from_city}, ${user?.from_state}`,
        }))
      );
      setToLocatonValue(
        callbackDataRoute?.to_location?.map((user) => ({
          label: `${user.to_city}, ${user?.to_state}`,
          value: `${user.to_city}, ${user?.to_state}`,
          name: `${user.to_city}, ${user?.to_state}`,
          _id: `${user.to_city}, ${user?.to_state}`,
        }))
      );
      setFromLoction(callbackDataRoute?.from_location);
      setToLoction(callbackDataRoute?.to_location);

      checkVal(callbackDataRoute);

      setcallbackDataRoute("");
    }
  }, [callbackDataRoute]);

  const checkVal = async () => {
    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...formValue,
          toLoction: callbackDataRoute?.to_location,
          fromLoction: callbackDataRoute?.from_location,
        },
        errorSchema.createTripSchima
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const checkVals = async (data) => {
    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...formValue,
          toLoction: data?.to_location,
          fromLoction: data?.from_location,
        },
        errorSchema.createTripSchima
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  useEffect(() => {
    if (LrDetele.item) {
      setConfirmModalShow(true);
    }
  }, [LrDetele]);


  // useEffect(() => {

  //   if ((searchValue.length == 1)) {
  //     fetchVehicleList(1, searchValue, true);
  //     setRefreshVehicleDropdown()
  //     setHasMoreVehicle(false);
  //   }

  //   if (searchValue.length == 0 && searchValue == "") {
  //     setPage(1);
  //     fetchVehicleList(1, "", true);
  //   }
  // }, [searchValue]);

  useEffect(() => {
    if (listOfLr) {

      const combinedMap = new Map();
      toLoction.forEach(loc => {
        const key = `${loc.to_city}|${loc.to_state}`;
        combinedMap.set(key, { ...loc, lr_list: [] });
      });

      listOfLr.forEach(entry => {
        entry.list.forEach(lr => {
          const { to_city, to_state } = lr.to;
          const key = `${to_city}|${to_state}`;

          if (!combinedMap.has(key)) {
            combinedMap.set(key, {
              to_city,
              to_state,
              lat: lr.to.lat,
              long: lr.to.long,
              lr_list: []
            });
          }

          combinedMap.get(key).lr_list.push(lr._id);
        });
      });

      // const combinedList = Array.from(combinedMap.values());
      const combinedList = toLoction.map((location, index) => {
        const list = listOfLr[index]?.list || [];
        const ids = list.map((item) => item._id);

        return {
          ...location,
          lr_list: ids,
        };
      });


      setFromLoction(prev => {
        const newList = [...prev];

        listOfLr.forEach(entry => {
          entry.list.forEach(lr => {
            const { from_city, from_state, lat, long } = lr.from;

            const exists = newList.some(loc =>
              loc.from_city === from_city && loc.from_state === from_state
            );

            if (!exists) {
              const newLocation = { from_city, from_state, lat, long };

              // Check for index with all empty string fields
              const emptyIndex = newList.findIndex(loc =>
                loc.from_city === "" &&
                loc.from_state === "" &&
                loc.lat === "" &&
                loc.long === ""
              );

              if (emptyIndex !== -1) {
                newList[emptyIndex] = newLocation; // Replace empty one
              } else {
                newList.push(newLocation); // Insert at index
              }
            }
          });
        });

        checkVals({ from_location: newList })

        return newList;
      });

      listOfLr.forEach(entry => {
        entry.list.forEach(lr => {
          const { to_city, to_state, lat, long } = lr.to;

          const exists = combinedList.some(loc =>
            loc.to_city === to_city && loc.to_state === to_state
          );

          if (!exists) {
            const newLocation = { to_city, to_state, lat, long };

            // Check for placeholder object with all fields empty
            const emptyIndex = combinedList.findIndex(loc =>
              loc.to_city === "" &&
              loc.to_state === "" &&
              loc.lat === "" &&
              loc.long === ""
            );

            if (emptyIndex !== -1) {
              combinedList[emptyIndex] = newLocation; // Fill empty slot
            } else {
              addDiv(); // Trigger UI update (as per your logic)
              addTable()
              // combinedList.splice(indexofTable, 0, newLocation); // Insert at index
              combinedList.push(newLocation);
            }
          }
        });
      });
      checkVals({ to_location: combinedList })
      setToLoction(combinedList);
    }

  }, [listOfLr]);


  useEffect(() => {

    if (listOfLr[0]?.to_location) {

      const updatedToLocation = toLoction.map(loc => {
        const fullLocation = `${loc.to_city}, ${loc.to_state}`;

        const match = listOfLr.find(item => item.to_location === fullLocation);

        return {
          // ...loc,
          list: match ? match.list : [] // attach list if match is found, else empty array
        };
      });
      setNewListOfLr(updatedToLocation)
    }

  }, [toLoction])

  const planFromLoc = (loc) => {
    return loc?.map((item) => item.from_city).join(" + ");
  };

  const planToLoc = (loc) => {
    return loc?.map((item) => item.to_city).join(" + ");
  };

  // useEffect(() => {

  //   if (!dispatchIndent) return;

  //   const from = planFromLoc(dispatchIndent?.from_location);
  //   const to = planToLoc(dispatchIndent?.to_location);

  //   if (dispatchIndent?.to_location?.length) {
  //     setDivCount(dispatchIndent?.to_location.length);
  //     dispatchIndent?.to_location.forEach(() => addTable());
  //   }

  //   if (from && to) {




  //     setFromLoction(
  //       dispatchIndent?.from_location.map(({ _id, ...rest }) => rest)
  //     );
  //     const ListTry = dispatchIndent?.to_location?.map(
  //       ({ _id, po_list, ...rest }) => rest
  //     )


  //     setToLoction(
  //       dispatchIndent?.to_location?.map(
  //         ({ _id, lr_list, po_list, ...rest }) => rest
  //       )
  //     );

  //     const transformedLocations = dispatchIndent?.to_location.map(
  //       (location, index) => ({
  //         list: location.lr_list.map(lr => ({ ...lr, tableIndex: index })),

  //       })
  //     );


  //     setListOfLr(transformedLocations);
  //     setNewListOfLr(transformedLocations)
  //     setSelectedLr(transformedLocations);

  //     if (dispatchIndent?.vehicle_id?.vehicle_status == 1) {
  //       setFormValue((prevFormValue) => ({
  //         ...prevFormValue,
  //         branch_id: dispatchIndent?.branch_id?._id,
  //         route_name: `${from}-${to}`,
  //         vehicle_type_id: dispatchIndent?.vehicle_type_id?._id,
  //         vehicle_id: dispatchIndent?.vehicle_id?._id
  //           ? dispatchIndent?.vehicle_id?._id
  //           : "",
  //         lorry_type_id: dispatchIndent?.lorry_type_id?._id,
  //         supplier_id: dispatchIndent?.vehicle_id?.supplier_id
  //           ? dispatchIndent?.vehicle_id?.supplier_id?._id
  //           : "",
  //         driver_id: dispatchIndent?.vehicle_id?.driver_id
  //           ? dispatchIndent?.vehicle_id?.driver_id?._id
  //           : "",
  //       }));

  //       setOwnerShip(dispatchIndent?.vehicle_id?.vehicle_ownership);

  //       setFormLabelValue((prevFormLabelValue) => ({
  //         ...prevFormLabelValue,
  //         route_name: { label: `${from}-${to}`, value: `${from}-${to}` },
  //         vehicle_id: {
  //           label: dispatchIndent?.vehicle_id?.vehicle_no
  //             ? `${dispatchIndent?.vehicle_id?.vehicle_no} | ${masterData?.vehicle_ownership[
  //             dispatchIndent?.vehicle_id?.vehicle_ownership
  //             ]
  //             }`
  //             : "",
  //           value: dispatchIndent?.vehicle_id?._id
  //             ? dispatchIndent?.vehicle_id?._id
  //             : "",
  //         },
  //         lorry_type_id: {
  //           label: dispatchIndent?.lorry_type_id?.lorry_type,
  //           value: dispatchIndent?.lorry_type_id?._id,
  //         },
  //         vehicle_type_id: {
  //           label: dispatchIndent?.vehicle_type_id?.name,
  //           value: dispatchIndent?.vehicle_type_id?._id,
  //         },

  //         supplier_id: dispatchIndent?.vehicle_id?.supplier_id?._id
  //           ? {
  //             label: dispatchIndent?.vehicle_id?.supplier_id?.name,
  //             value: dispatchIndent?.vehicle_id?.supplier_id?._id,
  //           }
  //           : { label: "", value: "" },
  //         driver_id: dispatchIndent?.vehicle_id?.driver_id?._id
  //           ? {
  //             label: dispatchIndent?.vehicle_id?.driver_id?.name,
  //             value: dispatchIndent?.vehicle_id?.driver_id?._id,
  //           }
  //           : { label: "", value: "" },
  //       }));

  //       setVehicleTypeLabel({
  //         label: `${dispatchIndent?.lorry_type_id?.lorry_type} > ${dispatchIndent?.vehicle_type_id?.name}`,
  //         value: "",
  //       });
  //     } else {
  //       setFormValue((prevFormValue) => ({
  //         ...prevFormValue,
  //         branch_id: dispatchIndent?.branch_id?._id,
  //         route_name: `${from}-${to}`,
  //       }));

  //       setOwnerShip(dispatchIndent?.vehicle_id?.vehicle_ownership);

  //       setFormLabelValue((prevFormLabelValue) => ({
  //         ...prevFormLabelValue,
  //         route_name: { label: `${from}-${to}`, value: `${from}-${to}` },

  //       }));

  //       vehicleStatusCheckFromPaln(dispatchIndent)

  //     }
  //   }
  // }, [dispatchIndent, location.pathname]);


  useEffect(() => {

    const initializeDispatchData = async () => {
      if (!dispatchIndent) return;

      const from = planFromLoc(dispatchIndent?.from_location);
      const to = planToLoc(dispatchIndent?.to_location);

      if (dispatchIndent?.to_location?.length) {
        setDivCount(dispatchIndent?.to_location.length);
        dispatchIndent?.to_location.forEach(() => addTable());
      }

      if (from && to) {
        setFromLoction(
          dispatchIndent?.from_location.map(({ _id, ...rest }) => rest)
        );

        const toLocationWithoutIds = dispatchIndent?.to_location?.map(
          ({ _id, lr_list, po_list, ...rest }) => rest
        );
        setToLoction(toLocationWithoutIds);

        const transformedLocations = dispatchIndent?.to_location.map(
          (location, index) => ({
            list: location.lr_list.map(lr => ({ ...lr, tableIndex: index })),
          })
        );

        const vehicleStatus = dispatchIndent?.vehicle_id?.vehicle_status;

        if (vehicleStatus === 1) {
          setFormValue(prev => ({
            ...prev,
            branch_id: dispatchIndent?.branch_id?._id,
            route_name: `${from}-${to}`,
            vehicle_type_id: dispatchIndent?.vehicle_type_id?._id,
            vehicle_id: dispatchIndent?.vehicle_id?._id || "",
            lorry_type_id: dispatchIndent?.lorry_type_id?._id,
            supplier_id: dispatchIndent?.vehicle_id?.supplier_id?._id || "",
            driver_id: dispatchIndent?.vehicle_id?.driver_id?._id || "",
          }));

          setOwnerShip(dispatchIndent?.vehicle_id?.vehicle_ownership);
          const findBrnach = branchList?.find((i) => i?._id == dispatchIndent?.branch_id?._id)

          setFormLabelValue(prev => ({
            ...prev,
            branch_id: branchList?.find((i) => i?._id === dispatchIndent?.branch_id?._id),
            route_name: { label: `${from}-${to}`, value: `${from}-${to}` },
            vehicle_id: {
              label: dispatchIndent?.vehicle_id?.vehicle_no
                ? `${dispatchIndent?.vehicle_id?.vehicle_no} | ${masterData?.vehicle_ownership[
                dispatchIndent?.vehicle_id?.vehicle_ownership
                ]
                }`
                : "",
              value: dispatchIndent?.vehicle_id?._id || "",
              _id: dispatchIndent?.vehicle_id?._id || "",
              vehicle_no: dispatchIndent?.vehicle_id?.vehicle_no || "",
              vehicle_ownership: dispatchIndent?.vehicle_id?.vehicle_ownership || ""
            },
            lorry_type_id: {
              label: dispatchIndent?.lorry_type_id?.lorry_type,
              value: dispatchIndent?.lorry_type_id?._id,
            },
            vehicle_type_id: {
              label: dispatchIndent?.vehicle_type_id?.name,
              value: dispatchIndent?.vehicle_type_id?._id,
            },
            supplier_id: dispatchIndent?.vehicle_id?.supplier_id?._id
              ? {
                label: dispatchIndent?.vehicle_id?.supplier_id?.name,
                value: dispatchIndent?.vehicle_id?.supplier_id?._id,
              }
              : { label: "", value: "" },
            driver_id: dispatchIndent?.vehicle_id?.driver_id?._id
              ? {
                label: dispatchIndent?.vehicle_id?.driver_id?.name,
                value: dispatchIndent?.vehicle_id?.driver_id?._id,
              }
              : { label: "", value: "" },
          }));

          setVehicleTypeLabel({
            label: `${dispatchIndent?.lorry_type_id?.lorry_type} > ${dispatchIndent?.vehicle_type_id?.name}`,
            value: "",
          });
        } else {
          setFormValue(prev => ({
            ...prev,
            branch_id: dispatchIndent?.branch_id?._id,
            route_name: `${from}-${to}`,
          }));

          setOwnerShip(dispatchIndent?.vehicle_id?.vehicle_ownership);

          setFormLabelValue(prev => ({
            ...prev,
            route_name: { label: `${from}-${to}`, value: `${from}-${to}` },
            branch_id: branchList?.find((i) => i?._id === dispatchIndent?.branch_id?._id)

          }));

          vehicleStatusCheckFromPaln(dispatchIndent);
        }

        setListOfLr(transformedLocations);
        setNewListOfLr(transformedLocations);
        setSelectedLr(transformedLocations);
      }
    };
    if (branchList?.length) initializeDispatchData();

  }, [dispatchIndent, location.pathname, branchList]);

  const fetchFromCity = async (search, page, limit) => {
    const res = await getCityLocationList({
      countryCode: "IN",
      stateCode: "",
      offset: page,
      limit,
      search,

    });
    if (res?.responseCode === 200) {
      const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };


  const vehicleStatusCheckFromPaln = (data) => {
    // setLastTripDetails("");


    if (data?.vehicle_id?.vehicle_status == 1) {
      // vehicleHandleChange(data);
      setVehicleStatus(data);
    } else if (data?.vehicle_id?.vehicle_status == 2) {
      setVehicleStatus(data?.vehicle_id);
      setShowEndTrip(true);
    } else if (data?.vehicle_id?.vehicle_status == 3) {
      setShowAvailableTruck(true);
      setVehicleStatus(data?.vehicle_id);
    } else {
      return;
    }
  };



  const fetchVehicleList = async (nextPage = 1, searchValue = "", isSearch = false) => {
    try {
      const vehicleRes = await getVehicleList(nextPage, searchValue ? 2000 : 10);

      if (vehicleRes?.responseCode === 200) {
        const newVehicles = vehicleRes.data?.vehicle_list.map((i) => ({
          ...i,
          label: i.vehicle_no,
          value: i._id,
        }));


        if (nextPage == "add" || isSearch) {
          setVehicleNumbList(newVehicles);
        } else {
          setVehicleNumbList((prevList) => [...prevList, ...newVehicles]);
        }

        // if (newVehicles.length < 10) {
        //   setHasMoreVehicle(false);
        // } else {
        //   setHasMoreVehicle(true);
        //   setPage(nextPage + 1);
        // }

        setHasMoreVehicle(newVehicles.length >= 10);
        if (newVehicles.length >= 10) {
          setPage((prev) => typeof prev === "number" ? prev + 1 : 2);
        }
      } else {
        toast.error(vehicleRes?.responseMessage);
      }
    } catch (error) {
      console.error("Error fetching vehicle list:", error);
      toast.error("Error fetching vehicle list.");
    }
  };


  const fetchVehicle = async (search, page, limit) => {
    const res = await getAllVehicleNumber({
      company_id: StorageService.getCompanyId(),
      offset: page,
      limit,
      search,
    });


    if (res?.responseCode === 200) {
      setLoading(false);
      const list = await res?.data?.vehicle_list?.map((i) => ({ ...i, label: i?.vehicle_no, value: i?.__id }))

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      setLoading(false);
      toast.error(res?.responseMessage);
    }
  };


  const fetchInitialData = async () => {
    try {

      const [
        branchRes,
        routeRes,
        // vehicleRes,
        driverRes,
        supplierRes,
        lorryTypeRes,
        consignorRes,
      ] = await Promise.all([
        getBranchList(),
        getRouteList(),
        // getVehicleList(),
        getDriverList(),
        getSupplierList(),
        getDataLorryTypeList(),
        getDataConsignorList(),
      ]);

      if (branchRes?.responseCode === 200) {
        handleListResponse(
          branchRes.data?.branch_list,
          "branch",
          setBranchList
        );
      } else {
        // toast.error(branchRes?.responseMessage);
      }

      if (routeRes?.responseCode === 200) {
        handleListResponse(routeRes.data?.route, "route_name", setRouteList);
      } else {
        // toast.error(routeRes?.responseMessage);
      }


      if (driverRes?.responseCode === 200) {
        setDriverList(
          driverRes.data?.driver_list.map((i) => ({
            ...i,
            label: i.name,
            value: i._id,
          }))
        );
      } else {
        // toast.error(driverRes?.responseMessage);
      }

      if (supplierRes?.responseCode === 200) {
        setSupplierList(
          supplierRes.data?.supplier_list.map((i) => ({
            ...i,
            label: i.name,
            value: i._id,
          }))
        );
      } else {
        // toast.error(supplierRes?.responseMessage);
      }

      if (lorryTypeRes?.responseCode === 200) {
        setLorryType(lorryTypeRes.data?.lorry_type);
      }

      if (consignorRes?.responseCode === 200) {
        handleListResponse(
          consignorRes.data?.consignor_list,
          "name",
          setConsignorList
        );
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
      toast.error("Error fetching initial data.");
    }
  };

  const handleListResponse = (listData, labelKey, setter) => {
    const list = listData.map((i) => ({
      ...i,
      label: i[labelKey],
      value: i._id,
    }));

    setter(list);

    if (list.length === 1 && !dispatchIndent) {
      setFormValue((prev) => ({
        ...prev,
        [labelKey == "branch" ? "branch_id" : labelKey]:
          labelKey == "route_name" ? list[0]?.label : list[0].value,
      }));
      setFormLabelValue((prev) => ({
        ...prev,
        [[labelKey == "branch" ? "branch_id" : labelKey]]: labelKey == "route_name" ? "" : list[0],
      }));
    }
  };

  const getBranchList = () => {
    return getBranchDropdownListData({
      company_id: StorageService.getCompanyId(),
      firm_id: StorageService.getFirmId(),
      // select_company_id: 1,
      // offset: page,
      // limit:2000,
    });
  };

  const getRouteList = () => {
    return getAllRoutes({
      company_id: StorageService.getCompanyId(),
      offset: page,
      limit: 2000,
    });
  };

  const getVehicleList = (page = 1, limit = 2000) => {
    return getAllVehicleNumber({
      company_id: StorageService.getCompanyId(),
      offset: page,
      limit,
    });
  };

  const getDriverList = () => {
    return getAllDriver({
      company_id: StorageService.getCompanyId(),
      offset: page,
      limit: 2000,
    });
  };

  const getSupplierList = () => {
    return getAllSupplier({
      company_id: StorageService.getCompanyId(),
      offset: page,
      limit: 2000
    });
  };

  const getDataLorryTypeList = () => {
    return getLorryTypeList();
  };

  const getDataConsignorList = () => {
    const object = {
      company_id: StorageService.getCompanyId(),
      limit: 2000,
      offset: 1,
      search: "",
      status: 1,
    };
    return getConsignorListData(object);
  };

  const getLastTripHandle = async (data) => {
    const res = await getLastTrip({
      company_id: StorageService.getCompanyId(),
      vehicle_id: data?._id,
    });
    if (res?.responseCode === 200) {
      setLastTripDetails(res.data?.trip);
      if (vehicleStatus?.vehicle_status == 1) {
        if (res.data?.trip?.end_kms) {
          setFormValue({ ...formValue, start_kms: res.data?.trip?.end_kms });
          setLastReading(res.data?.trip?.end_kms);
        } else {
          setFormValue({ ...formValue, start_kms: "" });
          setLastReading("");
        }
      }

      return true
      // setShowEndTrip(res.data?.trip);
    } else {
      toast.error(res?.responseMessage);
      return false
    }
  };

  const callbackSelectRoute = (data) => {
    setcallbackDataRoute(data);
    setFormValue({ ...formValue, route_name: data?.route_name });
    setFormLabelValue({
      ...formLabelValue,
      route_name: { ...data, label: data?.route_name },
    });
    getRouteList();
  };


  const callbackSelectLr = (data) => {
    setListOfLr((prevList) => {
      const updatedData = "tableIndex" in data ? data : { ...data, tableIndex: indexofTable };

      const newList = prevList.map((entry) => ({ ...entry, list: [...entry.list] }));

      while (newList.length <= indexofTable) {
        newList.push({ list: [] });
      }

      const exists = newList[indexofTable].list.some(
        (lr) => JSON.stringify(lr) === JSON.stringify(updatedData)
      );

      if (!exists) {
        newList[indexofTable].list.push(updatedData);
      }

      // Group updatedList instead of old state
      const flatList = newList.flatMap((i) => i?.list || []);

      const grouped = flatList.reduce((acc, item) => {
        const key = `${item.to_location}, ${item.to_state}` || "Unknown";
        acc[key] = acc[key] || [];
        acc[key].push(item);
        return acc;
      }, {});

      const groupedArray = Object.entries(grouped).map(([key, list]) => ({
        to_location: key,
        list,
      }));

      return groupedArray;
    });


    setSelectedLr((prevSelected) => {
      const updatedData = "tableIndex" in data ? data : { ...data, tableIndex: indexofTable };

      const newSelected = prevSelected.map((entry) => ({ ...entry, list: [...entry.list] }));

      // If index does not exist, expand the array up to that index
      while (newSelected.length <= indexofTable) {
        newSelected.push({ list: [] });
      }

      const exists = newSelected[indexofTable].list.some(
        (lr) => JSON.stringify(lr) === JSON.stringify(updatedData)
      );

      if (!exists) {
        newSelected[indexofTable].list.push(updatedData);
      }

      return newSelected;
    });

  };


  const addPartyWithoutLr = (data) => {


    if (!data?.party) {
      return;
    }

    const extractedData = { ...toLoction[indexofTable] };
    delete extractedData.lr_list;

    const partyIndex = listOfLr[indexofTable].list;

    // Extract the party object
    const newParty = {
      consignor_id: {
        name: data?.party?.label,
        _id: data?.party?.value,
      },
      from: fromLoction[0],
      from_location: fromLoction[0].from_city,
      from_state: fromLoction[0].from_state,
      to_location: extractedData.to_city,
      to_state: extractedData.to_state,
      to: extractedData,
      // lrIndex:partyIndex,
      tableIndex: indexofTable
    };


    // const newList = [...listOfLr];


    if (listOfLr[indexofTable]?.list?.length === 0) {

      addTable();
    }

    // if (newList.length === 0) {
    //   newList.push({ branch_id: "default", list: [newParty] });
    // } else {
    //   newList[indexofTable].list.push(newParty);  
    // }




    setListOfLr((prevList) => {
      const updatedList = [...prevList];

      // Ensure index exists
      if (!updatedList[indexofTable]) {
        updatedList[indexofTable] = { branch_id: "default", list: [] };
      } else {
        updatedList[indexofTable].list.push(newParty);
      }

      const newarray = updatedList.map((i) => [...i?.list]);
      const mergedArray1 = newarray.flat();

      const groupedByToLocation = mergedArray1.reduce((acc, item) => {
        const key = `${item.to_location}, ${item.to_state}` || "Unknown";

        if (!acc[key]) {
          acc[key] = [];
        }

        acc[key].push(item);

        return acc;
      }, {});
      const groupedArray = Object.entries(groupedByToLocation).map(([key, value]) => ({
        to_location: key,
        list: value
      }));

      return groupedArray;
      // return updatedList;
    });


    setSelectedLr((prevSelect) => {
      const updatedSelect = [...prevSelect];

      if (!updatedSelect[indexofTable]) {
        updatedSelect[indexofTable] = { branch_id: "default", list: [] };
      }

      const exists = updatedSelect[indexofTable].list.some(
        (item) => item.consignor_id._id === newParty.consignor_id._id
      );

      if (!exists) {
        updatedSelect[indexofTable].list.push(newParty);
      }

      return updatedSelect;
    });


    // setSelectedLr(newSelect);
    // setListOfLr(newList);
    setSelectParty(false)
  };



  const addDiv = () => {
    setDivCount((prevCount) => prevCount + 1);
  };

  // const addTable = () => {
  //   setTripTable([...tripTable, ""]);
  // };

  const addTable = () => {
    setTripTable((prevTripTable) => [...prevTripTable, ""]);
  };

  const [flag, setFlag] = useState("");

  const addFromInput = (e) => {
    // e.preventDefault();

    setFromLoction((preState) => {
      return [...preState, initiFrom];
    });

    setFromLocatonValue((preState) => {
      return [...preState, ""];
    });
  };

  const removeFromInput = (index) => {
    const newFromIput = [...fromLoction];
    const NewInputLocation = [...fromlocationValue];

    newFromIput.splice(index, 1);
    NewInputLocation.splice(index, 1);

    setFromLoction(newFromIput);
    setFromLocatonValue(NewInputLocation);
  };

  const removeToInput = (index) => {
    const newFromIput = [...toLoction];

    const NewInputLocation = [...tolocationValue];

    newFromIput.splice(index, 1);
    NewInputLocation.splice(index, 1);

    setToLoction(newFromIput);
    setToLocatonValue(NewInputLocation);
  };

  const addToInput = () => {
    setToLoction([...toLoction, initiTo]);
    setToLocatonValue([...tolocationValue, ""]);
    addDiv();
    setListOfLr([...listOfLr, { list: [] }]);
    setSelectedLr([...selectedLr, { list: [] }]);
  };

  useEffect(() => {
    const initializeDispatchData = async () => {
      if (lrDetialsFrom) {

        const newFromvalue = [...fromlocationValue];
        const newFrom = [...fromLoction];
        const newTovalue = [...tolocationValue];
        const newTo = [...toLoction];
        newFromvalue[0] = {
          label: `${lrDetialsFrom.from_location}, ${lrDetialsFrom?.from_state}`,
          value: `${lrDetialsFrom.from_location}, ${lrDetialsFrom?.from_state}`,
        };

        newFrom[0] = {
          from_city: `${lrDetialsFrom.from?.from_city}`,
          from_state: `${lrDetialsFrom.from?.from_state}`,
          lat: `${lrDetialsFrom.from?.lat}`,
          long: `${lrDetialsFrom.from?.long}`,
        };

        newTovalue[0] = {
          label: `${lrDetialsFrom.to_location}, ${lrDetialsFrom?.to_state}`,
          value: `${lrDetialsFrom.to_location}, ${lrDetialsFrom?.to_state}`,
        };

        newTo[0] = {
          to_city: `${lrDetialsFrom.to?.to_city}`,
          to_state: `${lrDetialsFrom.to?.to_state}`,
          lat: `${lrDetialsFrom.to?.lat}`,
          long: `${lrDetialsFrom.to?.long}`,
        };
        setFromLocatonValue(newFromvalue);
        setFromLoction(newFrom);
        setToLocatonValue(newTovalue);
        setToLoction(newTo);
        const updatedDetails = { ...lrDetialsFrom, tableIndex: 0 };
        addTable();
        const newList = [...listOfLr];
        const newSelect = [...selectedLr];
        newList[0]?.list.push(updatedDetails);
        newSelect[0]?.list.push(updatedDetails);

        // setListOfLr(newList);
        setListOfLr((pre) => {
          const newarray = newList.map((i) => [...i?.list]);
          const mergedArray1 = newarray.flat();

          const groupedByToLocation = mergedArray1.reduce((acc, item) => {
            const key = `${item.to_location}, ${item.to_state}` || "Unknown";

            if (!acc[key]) {
              acc[key] = [];
            }

            acc[key].push(item);

            return acc;
          }, {});
          const groupedArray = Object.entries(groupedByToLocation).map(([key, value]) => ({
            to_location: key,
            list: value
          }));

          return groupedArray;
        })


        setSelectedLr(newSelect);
        setLrDetialsFrom("");
      }
    }
    initializeDispatchData()
  }, [lrDetialsFrom]);

  let firstCreateRouteModal = {
    isOpen: showCreatRoute,
    closeModal: (e) => setShowCreatRoute(false),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Create Route",
    submitTitle: "Create Route",
    callbackSelectRoute: callbackSelectRoute,
  };

  let selectLrModalProps = {
    isOpen: showSelectLr,
    closeModal: (e) => setShowSelectLr(false),
    onSubmit: (e) => setShowSelectLr(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: " _dashCommon_Modal _xxlModal",
    modalTitle: "Select LR",
    submitTitle: "null",
    indexofTable: indexofTable,
    listOfLr: listOfLr,
    callbackSelectLr: callbackSelectLr,
    selectedLr: selectedLr,
    consignorList: consignorList,
    branchList: branchList,
    setSelectParty: setSelectParty,
  };

  const handleInputChange = async (value, index, label, tableIndex) => {
    setIndexofTable(tableIndex);

    if (label === "From City") {
      // let stateDetails;
      // let data = {
      //   countryCode: value?.countryCode,
      //   stateCode: value?.stateCode
      // }
      // let response = await getStatesData(data);
      // if (response?.responseCode === 200) {
      //   stateDetails = response?.data[0];
      // }

      // const stateDetails = State.getStateByCodeAndCountry(
      //   value?.stateCode,
      //   value?.countryCode
      // );
      const NewFromLocation = [...fromLoction];
      const NewInputLocation = [...fromlocationValue];
      NewFromLocation[index].from_city = value.name;
      NewFromLocation[index].from_state = value.stateName;
      NewFromLocation[index].lat = value?.latitude;
      NewFromLocation[index].long = value?.longitude;
      NewInputLocation[index] = {
        label: `${value.name}, ${value.stateName}`,
        value: `${value.name}, ${value.stateName}`,
        name: `${value.name}, ${value.stateName}`,
        _id: `${value.name}, ${value.stateName}`
      };
      setFromLocatonValue(NewInputLocation);
      setFromLoction(NewFromLocation);

      if (!!formError) {
        const validationResult = await utils.checkFormError(
          { ...formValue, toLoction: toLoction, fromLoction: NewFromLocation },
          errorSchema.createTripSchima
        );

        if (validationResult === true) {
          setFormError("");
        } else {
          setFormError(validationResult);
        }
      }
    }

    if (label === "To City") {
      // let stateDetails;
      // let data = {
      //   countryCode: value?.countryCode,
      //   stateCode: value?.stateCode
      // }
      // let response = await getStatesData(data);
      // if (response?.responseCode === 200) {
      //   stateDetails = response?.data[0];
      // }


      // const stateDetails = State.getStateByCodeAndCountry(
      //   value?.stateCode,
      //   value?.countryCode
      // );
      const NewToLocation = [...toLoction];
      const NewInputLocation = [...tolocationValue];
      NewToLocation[index].to_city = value.name;
      NewToLocation[index].to_state = value.stateName;
      NewToLocation[index].lat = value?.latitude;
      NewToLocation[index].long = value?.longitude;
      NewInputLocation[index] = {
        label: `${value.name}, ${value.stateName}`,
        value: `${value.name}, ${value.stateName}`,
        name: `${value.name}, ${value.stateName}`,
        _id: `${value.name}, ${value.stateName}`
      };

      setToLocatonValue(NewInputLocation);
      setToLoction(NewToLocation);

      if (!!formError) {
        const validationResult = await utils.checkFormError(
          { ...formValue, toLoction: NewToLocation, fromLoction: fromLoction },
          errorSchema.createTripSchima
        );

        if (validationResult === true) {
          setFormError("");
        } else {
          setFormError(validationResult);
        }
      }
    }
  };


  const removeDiv = (index, city, state) => {
    setDivCount((prevCount) => prevCount - 1);
    setFlag("delete");

    let newselectedLr = [...listOfLr];
    let newestListOfLr = [...newListOfLr];
    let newTolr = [...toLoction];

    // Clear lr_list of the removed item
    newTolr[index].lr_list = [];

    // Remove the matching LR from all selectedLr entries
    const updatedSelectedLr = selectedLr.map((group) => ({
      ...group,
      list: group.list.filter(
        (lr) => !(lr.to?.to_city === city && lr.to?.to_state === state)
      ),
    }));

    // Same filtering for listOfLr and newListOfLr
    newselectedLr = newselectedLr.map((group) => ({
      ...group,
      list: group.list.filter(
        (lr) => !(lr.to?.to_city === city && lr.to?.to_state === state)
      ),
    }));

    newestListOfLr = newestListOfLr.map((group) => ({
      ...group,
      list: group.list.filter(
        (lr) => !(lr.to?.to_city === city && lr.to?.to_state === state)
      ),
    }));

    // Reassign tableIndex
    const reassignTableIndex = (data) =>
      data.map((group, i) => ({
        ...group,
        list: group.list.map((lr) => ({ ...lr, tableIndex: i })),
      }));

    setSelectedLr(reassignTableIndex(updatedSelectedLr));
    setListOfLr(reassignTableIndex(newselectedLr));
    setNewListOfLr(reassignTableIndex(newestListOfLr));
    setToLoction(newTolr);

    removeToInput(index);
  };


  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...formValue,
      [name]:
        name === "branch_id" ||
          name === "driver_id" ||
          // name === "vehicle_id" ||
          name === "supplier_id"
          ? value.value
          : name === "route_name"
            ? value.label
            : value,
    };

    if (name === "supplier_id") {
      setFormTotal((pre) => ({ ...pre, tds_diduction: value?.tds_deduction }))
    }

    if (name === "vehicle_id") {
      stateObj["lorry_type_id"] = value?.lorry_type_id?._id;
      stateObj["vehicle_type_id"] = value?.vehicle_type_id_1?._id;
      stateObj["supplier_id"] = value?.supplier_id?._id
        ? value?.supplier_id?._id
        : "";
      stateObj["driver_id"] = value?.driver_id?._id
        ? value?.driver_id?._id
        : "";
      stateObj["vehicle_id"] = value?._id;
    }

    setFormValue(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...formTotal,
          ...stateObj,
          toLoction: toLoction,
          fromLoction: fromLoction,
          ownership: ownerShip,
          branchMandetry: formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight?.mandatory
        },
        errorSchema.createTripSchima
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleFreightOnChange = async (name, value) => {
    const stateObj = {
      ...formTotal,
      [name]: value,
    };
    setFormTotal(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...formValue,
          ...stateObj,
          toLoction: toLoction,
          fromLoction: fromLoction,
          ownership: ownerShip,
          branchMandetry: formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight.mandatory
        },
        errorSchema.createTripSchima
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleChange = async (name, value) => {
    const stateObj = {
      ...ewayForm,
      [name]: value,
    };

    setEwayForm(stateObj);
    if (!!formError) {
      const validationResult = await utils.checkFormError(
        stateObj,
        errorSchema.ewayBillSchima
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const addButtonAction = (data) => {
    setShowCreatRoute(true);
  };

  const vehicleStatusCheck = (data) => {
    // setLastTripDetails("");

    if (data?.vehicle_status == 1) {
      vehicleHandleChange(data);
      setVehicleStatus(data);
    } else if (data?.vehicle_status == 2) {
      setVehicleStatus(data);
      setShowEndTrip(true);
    } else {
      setShowAvailableTruck(true);
      setVehicleStatus(data);
    }
  };



  useEffect(() => {
    if (vehicleStatus) {
      getLastTripHandle(vehicleStatus);
    }
  }, [vehicleStatus]);

  useEffect(() => {
    if (formValue?.vehicle_id) {
      getLastTripHandle({ _id: formValue?.vehicle_id });
    }
  }, [formValue?.vehicle_id]);

  const vehicleHandleChange = (data) => {

    setOwnerShip(data?.vehicle_ownership);

    setFormLabelValue({
      ...formLabelValue,
      vehicle_id: {
        ...data,
        label: `${data.vehicle_no} | ${masterData?.vehicle_ownership[data?.vehicle_ownership]}`,
      },
      lorry_type_id: {
        label: data?.lorry_type_id?.lorry_type ? data?.lorry_type_id?.lorry_type : "",
        value: data?.lorry_type_id?._id ? data?.lorry_type_id?._id : "",
      },
      vehicle_type_id: {
        label: data?.vehicle_type_id_1?.name ? data?.vehicle_type_id_1?.name : "",
        value: data?.vehicle_type_id_1?._id ? data?.vehicle_type_id_1?._id : "",
      },
      supplier_id: data?.vehicle_ownership == 2 ? data?.supplier_id?._id
        ? {
          label: data?.supplier_id?.name ? data?.supplier_id?.name : "",
          value: data?.supplier_id?._id ? data?.supplier_id?._id : "",
        }
        : { label: "", value: "" } : { label: "", value: "" },
      driver_id: data?.driver_id?._id
        ? { label: data?.driver_id?.name, value: data?.driver_id?._id }
        : { label: "", value: "" },
    });

    setFormTotal((pre) => ({ ...pre, tds_diduction: data?.supplier_id?.tds_deduction }))

    // setFormValue({
    //   ...formValue,
    //   lorry_type_id: data?.lorry_type_id?._id,
    //   vehicle_type_id: data?.vehicle_type_id_1?._id,
    //   supplier_id: data?.supplier_id?._id ? data?.supplier_id?._id : "",
    //   driver_id: data?.driver_id?._id ? data?.driver_id?._id : "",
    //   vehicle_id: data?._id,
    // });

    handleOnChange("vehicle_id", data);

    setVehicleTypeLabel({
      label: data?.lorry_type_id?.lorry_type ? `${data?.lorry_type_id?.lorry_type ? data?.lorry_type_id?.lorry_type : ""} > ${data?.vehicle_type_id_1?.name ? data?.vehicle_type_id_1?.name : ""}` : "",
      value: "",
    });
  };

  const handleDelete = (item, index, indexTable) => {
    // let newLr = [...listOfLr];
    let newLr = [...newListOfLr];

    let newselectedLr = [...selectedLr];
    const newTolr = [...toLoction];

    newTolr[LrDetele?.outerIndex]?.lr_list?.splice(LrDetele?.innerIndex, 1);
    newLr[LrDetele?.outerIndex]?.list?.splice(LrDetele?.innerIndex, 1);
    newselectedLr[LrDetele?.outerIndex]?.list?.splice(LrDetele?.innerIndex, 1);

    const flatList = newLr.flatMap(item => item.list);  // Flatten all items
    const output = [{ list: flatList }];

    // setListOfLr(newLr);
    setNewListOfLr(newLr);
    setToLoction(newTolr);
    setSelectedLr(output);
    toast.success("LR Deleted");
    setConfirmModalShow(false);
    setLrDetele("");
  };

  //////freight modal

  useEffect(() => {
    if (newListOfLr) {
      const newarray = newListOfLr.map((i) => [...i?.list]);
      const mergedArray1 = newarray.flat();
      setAllFrightLr(mergedArray1);
    }
  }, [newListOfLr]);

  useEffect(() => {
    const updatedData = allFrightLr.map((item) => {
      return {
        ...item,
        consignor_Newid: item?.consignor_id?._id,
        freight_type: item?.lr_freight?.freight_type
          ? item?.lr_freight?.freight_type
          : 4,
        qty: item?.lr_freight?.qty ? item?.lr_freight?.qty : 0,
        rate: item?.lr_freight?.rate ? item?.lr_freight?.rate : 0,
        amount: item?.lr_freight?.total_freight
          ? item?.lr_freight?.total_freight
          : 0,
        lr_id: item?._id,
        selected: true,
      };
    });


    if (updatedData) setSeprateLr(separateSameValues(updatedData));
  }, [allFrightLr]);

  const separateSameValues = (arr) => {
    const grouped = arr?.reduce((acc, val) => {
      if (!acc[val?.consignor_id?._id]) {
        acc[val?.consignor_id?._id] = [];
      }
      acc[val?.consignor_id?._id].push(val);
      return acc;
    }, {});

    // return Object.values(grouped);
    return arr

  };

  const handleModalInputChange = (value, index, label, indexlr, field) => {
    setSeprateLr((prevData) =>
      prevData.map((item, index1) =>
        index1 === index
          ? item?.map((detail, index2) =>
            index2 === indexlr
              ? field === "freight_type" && value.value == 4
                ? { ...detail, qty: 0, rate: 0, amount: 0, freight_type: 4 }
                : { ...detail, [field]: value.value }
              : detail
          )
          : item
      )
    );
  };



  //   const mergeFreightData = (listOfLr, toLocation) => {
  //     return toLocation.map((toLoc, index) => {

  //       const matchingLrs = listOfLr
  //         .flatMap(k => k?.lr_list || []) // Flatten lr_list from each entry
  //         .filter(i => i?.tableIndex === index); // Filter matching tableIndex entries


  //       return {
  //         to_city: toLoc?.to_city,
  //         to_state: toLoc?.to_state,
  //         lat: String(toLoc?.lat),
  //         long: String(toLoc?.long),
  //         lr_freight: matchingLrs.map(lr => ({
  //           consignor_id: lr?.consignor_id?._id || '',
  //           eway_bill_number: lr?.eway_bill_number || '',
  //           eway_bill_date: lr?.eway_bill_date || '',
  //           eway_expiry_date: lr?.eway_expiry_date || '',
  //           freight_type: lr?.contract_rates?.freight_type,
  //           qty: lr?.contract_rates?.qty,
  //           rate: lr?.contract_rates?.rate,
  //           amount: lr?.contract_rates?.total_freight,
  //           lr_id: lr?._id || ''
  //         }))
  //       };
  //     });
  //   };
  const mergeFreightData = (listOfLr, toLocation) => {


    return toLocation.map((toLoc, index) => {
      // Get all LRs from all entries in listOfLr
      const allLrs = listOfLr.flatMap(k => k?.lr_list || []);

      // Filter LRs that match the current location's to_city
      const matchingLrs = allLrs.filter(lr => {
        return lr?.to_location === toLoc?.to_city;
      });

      return {
        to_city: toLoc?.to_city,
        to_state: toLoc?.to_state,
        lat: String(toLoc?.lat),
        long: String(toLoc?.long),
        lr_freight: matchingLrs.map(lr => ({
          consignor_id: lr?.consignor_id?._id || '',
          eway_bill_number: lr?.eway_bill_number || '',
          eway_bill_date: lr?.eway_bill_date || '',
          eway_expiry_date: lr?.eway_expiry_date || '',
          freight_type: lr?.contract_rates?.freight_type,
          qty: lr?.contract_rates?.qty,
          rate: lr?.contract_rates?.rate,
          amount: lr?.contract_rates?.total_freight,
          lr_id: lr?._id || ''
        }))
      };
    });
  };

  const onSubmit = async () => {
    let filterlist = [];
    setLoading(true);

    // const transformLrFreight = listOfFreight.map((lrfMain) => {


    //   const contract = lrfMain?.contract || {};
    //   const isChargeableOnFreight = contract.chargeable_on === 1;

    //   if (contract.highest_freight === 1 && contract.multiple_rates_allowed !== 1) {

    //     const maxAmount = Math.max(
    //       ...lrfMain.lr_list.map(item =>
    //         isChargeableOnFreight
    //           ? item?.lr_freight?.total_freight || 0
    //           : item?.contract_rates?.total_freight || 0
    //       )
    //     );

    //     return {
    //       ...lrfMain,
    //       lr_list: lrfMain.lr_list.map((lrInner) => {
    //         const sourceRates = isChargeableOnFreight ? lrInner.lr_freight : lrInner.contract_rates;
    //         const currentAmount = sourceRates?.total_freight || 0;

    //         return {
    //           ...lrInner,
    //           contract_rates: {
    //             ...sourceRates,
    //             total_freight: currentAmount === maxAmount ? currentAmount : 0
    //           }
    //         };
    //       })
    //     };
    //   }

    //   // if contarct null then lrfreight and chargable true then lr
    //   // For normal case when highest_freight is not set
    //   return {
    //     ...lrfMain,
    //     lr_list: lrfMain.lr_list.map((lrInner) => ({
    //       ...lrInner,
    //       contract_rates: {
    //         // ...(isChargeableOnFreight || !lrfMain?.contract ? lrInner.lr_freight : lrInner.contract_rates)
    //         // ...(lrInner.contract_rates)

    //         ...(lrfMain?.contract ? isChargeableOnFreight ? lrInner.lr_freight : lrInner.contract_rates : lrInner.contract_rates)
    //       }
    //     }))
    //   };
    // });


    // const transformLrFreight = listOfFreight.map((lrfMain) => {
    //   const contract = lrfMain?.contract || {};
    //   const isChargeableOnFreight = contract.chargeable_on === 1;

    //   // Case 1: highest_freight = 1 && multiple_rates_allowed != 1
    //   if (contract.highest_freight === 1 && contract.multiple_rates_allowed !== 1) {
    //     const maxAmount = Math.max(
    //       ...lrfMain.lr_list.map(item =>
    //         isChargeableOnFreight
    //           ? item?.lr_freight?.total_freight || 0
    //           : item?.contract_rates?.total_freight || 0
    //       )
    //     );

    //     return {
    //       ...lrfMain,
    //       lr_list: lrfMain.lr_list.map((lrInner) => {
    //         const sourceRates = isChargeableOnFreight ? lrInner.lr_freight : lrInner.contract_rates;
    //         const currentAmount = sourceRates?.total_freight || 0;

    //         return {
    //           ...lrInner,
    //           contract_rates: {
    //             ...sourceRates,
    //             total_freight: currentAmount === maxAmount ? currentAmount : 0
    //           }
    //         };
    //       })
    //     };
    //   }

    //   // ✅ Case 2: highest_freight = 1 && multiple_rates_allowed = 1
    //   if (contract.highest_freight === 1 && contract.multiple_rates_allowed === 1) {
    //     return {
    //       ...lrfMain,
    //       lr_list: lrfMain.lr_list.map((lrInner) => {
    //         const sourceRates = isChargeableOnFreight ? lrInner.lr_freight : lrInner.contract_rates;
    //         const isSelected = sourceRates?.selected;

    //         return {
    //           ...lrInner,
    //           contract_rates: {
    //             ...sourceRates,
    //             total_freight: isSelected ? sourceRates.total_freight || 0 : 0
    //           }
    //         };
    //       })
    //     };
    //   }

    //   // ✅ Case 3: Normal flow when highest_freight is not set
    //   return {
    //     ...lrfMain,
    //     lr_list: lrfMain.lr_list.map((lrInner) => ({
    //       ...lrInner,
    //       contract_rates: {
    //         ...(lrfMain?.contract
    //           ? isChargeableOnFreight
    //             ? lrInner.lr_freight
    //             : lrInner.contract_rates
    //           : lrInner.contract_rates)
    //       }
    //     }))
    //   };
    // });

    const transformLrFreight = listOfFreight.map((lrfMain) => {
      const contract = lrfMain?.contract || {};
      const isChargeableOnFreight = contract.chargeable_on === 1;

      // Case 1: highest_freight = 1 && multiple_rates_allowed != 1
      if (contract.highest_freight === 1 && contract.multiple_rates_allowed !== 1) {
        const maxAmount = Math.max(
          ...lrfMain.lr_list.map(item =>
            isChargeableOnFreight
              ? item?.lr_freight?.total_freight || 0
              : item?.contract_rates?.total_freight || 0
          )
        );

        return {
          ...lrfMain,
          lr_list: lrfMain.lr_list.map((lrInner) => {
            const sourceRates = isChargeableOnFreight ? lrInner.lr_freight : lrInner.contract_rates;
            const currentAmount = sourceRates?.total_freight || 0;

            return {
              ...lrInner,
              contract_rates: {
                ...sourceRates,
                total_freight: currentAmount === maxAmount ? currentAmount : 0
              }
            };
          })
        };
      }

      // Case 2: highest_freight = 1 && multiple_rates_allowed = 1
      if (contract.highest_freight === 1 && contract.multiple_rates_allowed === 1) {
        return {
          ...lrfMain,
          lr_list: lrfMain.lr_list.map((lrInner) => {
            const sourceRates = isChargeableOnFreight ? lrInner.lr_freight : lrInner.contract_rates;
            const isSelected = sourceRates?.selected;

            return {
              ...lrInner,
              contract_rates: {
                ...sourceRates,
                total_freight: isSelected ? sourceRates.total_freight || 0 : 0
              }
            };
          })
        };
      }

      // ✅ Case 3: highest_freight != 1 && multiple_rates_allowed == 1 (check selected flag)
      if (contract.highest_freight !== 1 && contract.multiple_rates_allowed === 1) {
        return {
          ...lrfMain,
          lr_list: lrfMain.lr_list.map((lrInner) => {
            const sourceRates = isChargeableOnFreight ? lrInner.lr_freight : lrInner.contract_rates;
            const isSelected = sourceRates?.selected;

            return {
              ...lrInner,
              contract_rates: {
                ...sourceRates,
                total_freight: isSelected ? sourceRates.total_freight || 0 : 0
              }
            };
          })
        };
      }

      // ✅ Case 4: Normal flow
      return {
        ...lrfMain,
        lr_list: lrfMain.lr_list.map((lrInner) => ({
          ...lrInner,
          contract_rates: {
            ...(lrfMain?.contract
              ? isChargeableOnFreight
                ? lrInner.lr_freight
                : lrInner.contract_rates
              : lrInner.lr_freight)
          }
        }))
      };
    });


    const modifyLocation = mergeFreightData(transformLrFreight, toLoction);

    const transformedData = listOfFreight
      .map((consignor) => ({
        ...consignor,
        lr_list: consignor.lr_list.filter((lr) =>
          consignor?.contract?.chargeable_on === 2
            ? lr.contract_rates.selected
            : lr.lr_freight.selected
        ),
      }))
      .filter((consignor) => consignor.lr_list.length > 0)
      .flatMap((consignor) =>
        consignor.lr_list.map((lr) => {
          const rateType =
            consignor?.contract?.chargeable_on === 2
              ? lr.contract_rates.freight_type
              : lr.lr_freight.freight_type;
          const qty =
            consignor?.contract?.chargeable_on === 2
              ? lr.contract_rates.qty == 0 || lr.contract_rates.qty == null
                ? 0
                : lr.contract_rates.qty
              : lr.lr_freight.qty == 0 || lr.lr_freight.qty == null
                ? 0
                : lr.lr_freight.qty;
          const rate =
            consignor?.contract?.chargeable_on === 2
              ? lr.contract_rates.rate == 0 || lr.contract_rates.rate == null
                ? 0
                : lr.contract_rates.rate
              : lr.lr_freight.rate == 0 || lr.lr_freight.rate == null
                ? 0
                : lr.lr_freight.rate;
          const amount =
            qty && rate
              ? qty * rate
              : consignor?.contract?.chargeable_on === 2
                ? lr.contract_rates.total_freight == 0 ||
                  lr.contract_rates.total_freight == null
                  ? 0
                  : lr.contract_rates.total_freight
                : lr.lr_freight.total_freight == 0 ||
                  lr.lr_freight.total_freight == null
                  ? 0
                  : lr.lr_freight.total_freight;

          return {
            consignor_id: consignor.consignor_id,
            freight_type: rateType,
            qty,
            rate,
            amount,
            lr_id: lr._id,
          };
        })
      );


    const filteredArray1 = listOfFreight
      .map((consignor) => ({
        consignor_id: consignor.consignor_id,
        lr_list: consignor.lr_list
          // .filter(lr => lr.contract_rates.selected)
          .map((lr) => lr._id),
      }))
      .filter((consignor) => consignor.lr_list.length > 0);

    const allFromLocation = fromLoction.map((i) => {
      return {
        from_city: i?.from_city,
        from_state: i?.from_state,
        lat: String(i?.lat),
        long: String(i?.long),
      };
    });

    const allToLocation = toLoction.map((i) => {
      return {
        to_city: i?.to_city,
        to_state: i?.to_state,
        lat: String(i?.lat),
        long: String(i?.long),
      };
    });

    const formateChange = (data) => {
      const formate = data?.map((i) => {
        return {
          ...i,
          lat: String(i?.lat),
          long: String(i?.long),
        };
      });

      return formate;
    };

    let payload = {
      branch_id: formValue?.branch_id,
      company_id: StorageService?.getCompanyId(),
      // consignor_list: filteredArray1,
      dispatch_date: utils.convertToISO(formValue?.dispatch_date, true),
      driver_id: formValue?.driver_id || "",
      end_kms: formValue?.end_kms,
      from_location: formateChange(fromLoction),
      to_location: formateChange(modifyLocation),
      lorry_type_id: formValue?.lorry_type_id,
      // lr_freight: transformedData,
      route_name: formValue?.route_name,
      start_kms: formValue?.start_kms ? formValue?.start_kms : "",
      supplier_id: ownerShip == 2 ? formValue?.supplier_id : "",
      vehicle_id: formValue?.vehicle_id,
      vehicle_type_id: formValue?.vehicle_type_id,
      supplier_freight: formTotal.amount == 0 || formTotal.amount == "" || ownerShip != 2 ? null : formTotal,
      loading_challi: challiValues,
      ...(dispatchIndent ? { plan_id: dispatchIndent._id } : {}),
    };

    try {
      const res = await dispatch(addTrip(payload));
      if (res?.payload?.responseCode === 200) {
        setLoading(false);
        toast.success(res?.payload?.responseMessage);

        setShow(false);
        setFormValue({ ...intialForm });
        setSelectedLr([]);
        navigate(`/trip/addtrip/dispatched/${res?.payload?.data?.trip?._id}`);
        setDispatchIndent('')
      } else {
        toast.error(res?.payload?.responseMessage);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const callBackVehicleType = (value) => {
    setFormValue({
      ...formValue,
      lorry_type_id: value?.activeTab?._id,
      vehicle_type_id: value?.tyre?.value,
    });
    setVehicleTypeLabel({
      label: `${value?.activeTab?.lorry_type} > ${value?.tyre?.label}`,
      value: "",
    });
    setVehicleTypeShow(false);
  };

  const ewayBillHandle = async (i) => {
    try {
      let object = {
        company_id: StorageService?.getCompanyId(),
        lr_id: i?._id,
      };
      const res = await getDataLrDetails(object);

      if (res?.responseCode === 200) {
        setEwayBillId(res?.data?.lr);
        setEwayForm({
          ...ewayForm,
          start_date: res?.data?.lr?.eway_bill_date,
          end_date: res?.data?.lr?.eway_expiry_date,
          eway_bill_number: res?.data?.lr?.eway_bill_number,
        });
        setEwaybillShow(true);
      }
    } catch (error) {
      // throw error;
    }
  };

  const updateEwayBillNumber = (id, newEwayBillNumber) => {
    setListOfLr((prevState) =>
      prevState.map((lr) => {
        if (lr.list && lr.list.length) {
          return {
            ...lr,
            list: lr.list.map((item) => {
              if (item._id == id?._id) {
                return {
                  ...item,
                  eway_bill_number: newEwayBillNumber?.eway_bill_number,
                  eway_bill_date: newEwayBillNumber?.eway_bill_date,
                  eway_expiry_date: newEwayBillNumber?.eway_expiry_date,
                };
              }
              return item;
            }),
          };
        }
        return lr;
      })
    );
  };

  const handleEwayBillUpdate = async () => {
    const validationResult = await utils.checkFormError(
      { ...ewayForm },
      errorSchema.ewayBillSchima
    );
    const payload = {
      lr_id: ewayBillId?._id,
      eway_bill_number: ewayForm?.eway_bill_number,
      eway_bill_date: ewayForm?.start_date,
      eway_expiry_date: ewayForm?.end_date,
    };

    if (validationResult === true) {
      const res = await dispatch(addEwayWill(payload));

      if (res?.payload?.responseCode === 200) {
        setEwaybillShow(false);
        updateEwayBillNumber(ewayBillId, res?.payload?.data?.lr);
        setEwayForm({
          ...ewayForm,
          start_date: new Date(),
          end_date: new Date(),
          eway_bill_number: "",
        });
      } else {
        throw new Error(res?.payload?.responseMessage);
      }
    } else {
      setFormError(validationResult);
    }
  };

  const onValidationCheck = async () => {
    const validationResult = await utils.checkFormError(
      {
        ...formValue,
        ...formTotal,
        manage_trip_kms: vehicleStatus?.manage_trip_kms,
        toLoction: toLoction,
        fromLoction: fromLoction,
        ownership: ownerShip,
        branchMandetry: formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight?.mandatory,
        loadingChalliMandatory: Number(formLabelValue?.branch_id?.loading_challi?.mandatory) || 0,
        loadingChalli: challiValues,
        marketDriverMandatory: formLabelValue?.branch_id?.market_drive_on_dispatch?.mandatory
      },
      errorSchema.createTripSchima
    );

    if (validationResult === true) {
      if (allFrightLr.length == 0) {
        setShowWithOutLrModal(true)
      } else {
        setShow(!show);
      }
    } else {
      setFormError(validationResult);
    }
  };

  let firstAddLrModal = {
    isOpen: show,
    onSubmit: onSubmit,
    closeModal: (e) => setShow(false),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _xlModal",
    modalTitle: "LR Freight",
    submitTitle: "Dispatch",
    separateLr: separateLr,
    isLoadding: loading,
    disabled: loading,
    setLoading: setLoading,
    loading: loading,
    setListOfFreight: setListOfFreight,
    listOfFreight: listOfFreight,
    ownerShip: ownerShip,
    formValue: formValue,
  };

  let confirmModalProps = {
    show: confirmModalShow,
    closeModal: (e) => setConfirmModalShow(false),
    title: "Confirm",
    submitTitle: "Delete",
    onSubmit: handleDelete,
    confirmModal: "confirmModal",
    icon: Images.DELETEICON.default,
  };

  let ewaybillprops = {
    show: ewaybillShow,
    closeModal: (e) => setEwaybillShow(false),
    title: "Update",
    submitTitle: "Update",
    onSubmit: handleEwayBillUpdate,
    icon: images.EDIT,
    isLoadding: ewayLoading,
    disabled: ewayLoading,
  };

  let vehicleTypeProps = {
    isOpen: vehicleTypeshow,
    closeModal: (e) => setVehicleTypeShow(false),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Vehicle Type",
    submitTitle: "Save",
    isLoadding: loading,
    disabled: loading ? true : false,
    lorryType: lorryType,
    callBackVehicleType: callBackVehicleType,
  };

  const handleDelteSubmit = (i, innerIndex, outerIndex) => {
    setLrDetele({
      ...LrDetele,
      item: i,
      innerIndex,
      outerIndex,
      title: `${i?.from_location} TO ${i?.to_location} Lr`,
    });
  };

  const addVehicleHandle = (data) => {
    setShowOffcanvas(true);
  };

  const addSupplierHandle = (data) => {
    setShowOffcanvasSupplier(true);
  };

  const addDriverHandle = (data) => {
    if (ownerShip == 2) {
      setShowOffcanvasMarketDriver(true)
    } else {
      setShowOffcanvasDriver(true);
    }

  };

  const callBackVehicle = async (data) => {
    await vehicleHandleChange(data);
    await setVehicleStatus(data);
    setTimeout(() => {
      // fetchVehicleList("add");
      setRefreshVehicleDropdown(prev => prev + 1);
      // fetchVehicle()
      fetchInitialData();
    }, 2000);
  };

  const callBackSupplier = (data) => {
    setFormValue({ ...formValue, supplier_id: data?._id });
    const object = {
      ...data,
      label: data?.name,
      value: data?._id,
    };
    setFormLabelValue({ ...formLabelValue, supplier_id: object });
    const newSupplierList = [object, ...supplierList];
    setSupplierList(newSupplierList);
  };

  const callBackDriver = (data) => {
    setFormValue({ ...formValue, driver_id: data?._id });
    const object = {
      ...data,
      label: data?.name,
      value: data?._id,
    };
    setFormLabelValue({ ...formLabelValue, driver_id: object });
    const newDriverList = [object, ...driverList];
    setDriverList(newDriverList);
  };

  const handleDetailsAction = async (data) => {
    setShowLrDetail(data);
  };

  const callBackEnd = async (data) => {
    setOwnerShip(data?.vehicle_id?.vehicle_ownership);

    setFormLabelValue({
      ...formLabelValue,
      vehicle_id: {
        label: `${data?.vehicle_id?.vehicle_no} | ${masterData?.vehicle_ownership[data?.vehicle_id?.vehicle_ownership]
          }`,
        _id: data?.vehicle_id?._id || "",
        vehicle_no: data?.vehicle_id?.vehicle_no || "",
        vehicle_ownership: data?.vehicle_id?.vehicle_ownership || ""
      },
      lorry_type_id: {
        label: data?.lorry_type_id?.lorry_type,
        value: data?.lorry_type_id?._id,
      },
      vehicle_type_id: {
        label: data?.vehicle_type_id?.name,
        value: data?.vehicle_type_id?._id,
      },
      supplier_id: vehicleStatus?.supplier_id?._id
        ? {
          label: vehicleStatus?.supplier_id?.name,
          value: vehicleStatus?.supplier_id?._id,
        }
        : { label: "", value: "" },
      driver_id: vehicleStatus?.driver_id?._id
        ? { label: vehicleStatus?.driver_id?.name, value: vehicleStatus?.driver_id?._id }
        : { label: "", value: "" },
    });

    setFormValue({
      ...formValue,
      lorry_type_id: data?.lorry_type_id?._id,
      vehicle_type_id: data?.vehicle_type_id?._id,
      supplier_id: vehicleStatus?.supplier_id?._id || "",
      driver_id: vehicleStatus?.driver_id?._id || "",
      vehicle_id: data?.vehicle_id?._id,
      start_kms: data?.end_kms,
    });

    setLastReading(data?.end_kms);
    setVehicleTypeLabel({
      label: `${data?.lorry_type_id?.lorry_type} > ${data?.vehicle_type_id?.name}`,
      value: "",
    });

    // fetchVehicleList("add");
    setRefreshVehicleDropdown(true)

    const validationResult = await utils.checkFormError(
      {

        ...formValue,
        lorry_type_id: data?.lorry_type_id?._id,
        vehicle_type_id: data?.vehicle_type_id?._id,
        supplier_id: data?.supplier_id?._id ? data?.supplier_id?._id : "",
        driver_id: vehicleStatus?.driver_id?._id ? vehicleStatus?.driver_id?._id : "",
        vehicle_id: data?.vehicle_id?._id,
        start_kms: data?.end_kms,
      },
      errorSchema.createTripSchima
    );

    setFormError(validationResult);

  };

  const handleNextModal = (data) => {
    setShowLrDetail(!showLrDetail);
    setShowAddLR(data);
  };

  let selectPartyModal = {
    isOpen: selectParty,
    closeModal: (e) => setSelectParty(false),
    addButtonAction: (e) => setIsAddConsignor(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add LR",
    submitTitle: "Continue & Add LR",
    nextModal: (e) => setShowAddLR(e),
    showPrefield: showPrefield,
    showingPrefield: (e) => setShowingPrefield(e),
    secondSubmit: addPartyWithoutLr,
    filledLocation: {
      from: fromLoction[0],
      to: toLoction[indexofTable]
    }
  };

  const callBackDataLr = (lr) => {

    const modifyLr = { ...lr }

    const initialFunction = async (data) => {
      if (data?.branch_id) {
        // Add table if it does not exist
        if (!listOfLr.some((table) => table.branch_id === data.branch_id)) {
          addTable();
        }

        const tableIndex = listOfLr.findIndex((table) =>
          table.list.some((lrItem) => lrItem._id === data._id)
        );

        const updatedData = "tableIndex" in data ? data : { ...data, tableIndex: indexofTable };

        if (tableIndex !== -1) {
          const lrIndex = listOfLr[tableIndex].list.findIndex(
            (lrItem) => lrItem._id === data._id
          );

          // Update the existing LR
          const newList = listOfLr.map((table, index) =>
            index === tableIndex
              ? {
                ...table,
                list: table.list.map((lrItem, i) =>
                  i === lrIndex ? updatedData : lrItem
                ),
              }
              : table
          );

          const newSelect = selectedLr.map((table, index) =>
            index === tableIndex && table.list[lrIndex]
              ? {
                ...table,
                list: table.list.map((lrItem, i) =>
                  i === lrIndex ? updatedData : lrItem
                ),
              }
              : table
          );

          setSelectedLr(newSelect);
          // setListOfLr(newList);
          setListOfLr((pre) => {
            const newarray = newList.map((i) => [...i?.list]);
            const mergedArray1 = newarray.flat();

            const groupedByToLocation = mergedArray1.reduce((acc, item) => {
              const key = `${item.to_location}, ${item.to_state}` || "Unknown";

              if (!acc[key]) {
                acc[key] = [];
              }

              acc[key].push(item);

              return acc;
            }, {});
            const groupedArray = Object.entries(groupedByToLocation).map(([key, value]) => ({
              to_location: key,
              list: value
            }));

            return groupedArray;
          })
        } else {
          // LR is not already added
          const newList = [...listOfLr];

          if (!newList[indexofTable]) {
            newList[indexofTable] = { list: [] };
          }

          if (!newList[indexofTable].list.some((lrItem) => lrItem._id === data._id)) {
            newList[indexofTable].list.push(updatedData);

            const newSelect = [...selectedLr];
            if (!newSelect[indexofTable]) {
              newSelect[indexofTable] = { list: [] };
            }
            newSelect[indexofTable] = {
              ...newSelect[indexofTable],
              list: [...(newSelect[indexofTable]?.list || []), updatedData],
            };



            setSelectedLr(newSelect);
            // setListOfLr(newList);
            setListOfLr((pre) => {
              const newarray = newList.map((i) => [...i?.list]);
              const mergedArray1 = newarray.flat();

              const groupedByToLocation = mergedArray1.reduce((acc, item) => {
                const key = `${item.to_location}, ${item.to_state}` || "Unknown";

                if (!acc[key]) {
                  acc[key] = [];
                }

                acc[key].push(item);

                return acc;
              }, {});
              const groupedArray = Object.entries(groupedByToLocation).map(([key, value]) => ({
                to_location: key,
                list: value
              }));

              return groupedArray;
            })
          } else {
          }
        }
      }
    }
    initialFunction(modifyLr)

  };


  let endTripModal = {
    isOpen: showEndTrip,
    closeModal: (e) => {
      setShowEndTrip(false);
    },
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "End Previous Trip",
    submitTitle: "End Trip",
    callBackEnd: callBackEnd,
    lastTripDetails: lastTripDetails,
    endTripFrom: "Trip",
    dispatchIndent: dispatchIndent
  };

  let makeTruckModal = {
    isOpen: showAvailableTruck,
    closeModal: (e) => setShowAvailableTruck(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Make Truck Available",
    submitTitle: "Mark Available",
  };

  const handleAddNewSupplierButtonAction = () => {
    // setShowOffcanvasOfVehical(false);
    setIsSupplier(false);
    setShowOffcanvasOfSupplier(true);
  };

  const handleAddNewVehicleButtonAction = () => {
    // setShowOffcanvasOfVehical(false);
    setIsDriver(false);
    setShowOffcanvasOfDriver(true);
  };

  const handleSupplierNextModal = () => {
    setIsSupplier(!isSupplier);
    setShowOffcanvas(true);
  };

  const handleDriverNextModal = () => {
    setIsDriver(!isDriver);
    setShowOffcanvas(true);
  };

  const handleChalliChange = async (values) => {
    setChalliValues(values);
    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...formValue,
          ...formTotal,
          toLoction: toLoction,
          fromLoction: fromLoction,
          ownership: ownerShip,
          branchMandetry: formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight.mandatory,
          loadingChalliMandatory: Number(formLabelValue?.branch_id?.loading_challi?.mandatory) || 0,
          loadingChalli: values,

        },
        errorSchema.createTripSchima
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const callBackDataMap = async (data) => {
    if (typeOfDropdown.type == "from") {
      const newData = { ...data, _id: data?.name, label: `${data?.name}, ${data?.stateName}` }

      handleInputChange(newData, typeOfDropdown?.index1, "From City", "")
    }
    if (typeOfDropdown.type == "to") {
      const newData = { ...data, _id: data?.name, label: `${data?.name}, ${data?.stateName}` }
      handleInputChange(newData, typeOfDropdown?.index1, "To City", typeOfDropdown?.index)

    }

    fetchFromCity()
  }

  const addNewItemHandler = (e, type, index1, index) => {

    setOpenLoction(true)
    setTypeOfDropdown((i) => ({
      ...i,
      type, index1, index
    }))
    // nextModal(true);
    // closeModal(false);
  }

  let gmapLocate = {
    isOpen: openLoction,
    closeModal: (e) => setOpenLoction(false),
    modalMainClass: "_dashCommon_Modal _mdModalLoction",
    modalTitle: 'Add Location',
    submitTitle: 'Add Location',
    callBackDataMap: callBackDataMap
  };


  return (
    <>
      {branchList.length > 0 ? (
        <>
          <Heading title={"Create Trip"} />

          <div className="_addContainer bg-[#FBF9FB]">
            <div className="_midCont_body">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-xl-12">
                    <div className="_crtDisp_listBx" style={{maxWidth:'1380px', width:'100%'}}>
                      <div className="">
                        <div className="_fleX_inds">
                          <div className="_divForth">
                            <CustomSelect
                              label="Branch"
                              placeholder="Select Branch"
                              options={branchList}
                              onSelect={(data) => {

                                handleOnChange("branch_id", data);
                                setFormLabelValue({
                                  ...formLabelValue,
                                  branch_id: data,
                                });
                              }}
                              error={formError.branch_id}
                              value={branchList?.find(
                                (item) => item?.value == formValue?.branch_id
                              )}
                            />
                          </div>

                          <div className="_divForth">
                            {/* <CommonInput
                          label="Date of Dispatch"
                          type="date"
                          value={formValue.dispatch_date}
                          name="dispatch_date"
                          onChange={({ target: { name, value } }) =>
                            handleOnChange(name, value)
                          }
                        /> */}
                            <CommonDatePicker
                              name="dispatch_date"
                              label="Date of Dispatch"
                              startDate={formValue?.dispatch_date}
                              setStartDate={(data) => {
                                handleOnChange("dispatch_date", data);
                                // setStartDate(data);
                              }}
                              disabled={formLabelValue?.branch_id?.dispatch_date_time == 1}
                              error={formError.dispatch_date}
                              value={formLabelValue.dispatch_date}
                            />
                          </div>

                          <div className="_divForth">
                            <CustomSelect
                              label="Route"
                              placeholder="Select Route"
                              options={routeList}
                              isAddButton={true}
                              onSelect={(data) => {
                                handleOnChange("route_name", data);

                                setFormLabelValue({
                                  ...formLabelValue,
                                  route_name: data,
                                });
                                setcallbackDataRoute(data);
                                setLrDetialsFrom("");
                              }}
                              addButtonAction={addButtonAction}
                              error={formError.route_name}
                              value={formLabelValue.route_name}
                            />
                          </div>

                          {/* <div>
                        <button
                          onClick={() => setShowCreatRoute(!showCreatRoute)}
                        >
                          Add new route
                        </button>
                      </div> */}
                        </div>
                      </div>

                      <div className="">
                        <h4 className="_disPatch_heads">Dispatch Details</h4>
                        <div className="_fleX_inds">
                          <div className="_divForth __trps_select">
                            {/* <CustomSelect
                              label="Vehicle Number"
                              placeholder="Select Vehicle Number"
                              options={vehicleNumbList}
                              component_class="vehicle_number_trip"
                              onSelect={(data) => {
                                // handleOnChange("vehicle_id", data);
                                vehicleStatusCheck(data);
                                setOwnerShip(data?.vehicle_ownership);
                              }}
                              error={formError.vehicle_id}
                              value={formLabelValue.vehicle_id}
                              isAddButton={true}
                              addButtonAction={addVehicleHandle}
                              enableInfiniteScroll={
                                vehicleNumbList.length > 4 ? true : false
                              }
                              fetchMoreData={() => fetchVehicleList(page)}
                              hasMore={hasMoreVehicle}
                              setSearchValue={setSearchValue}
                              searchValue={searchValue}
                            /> */}

                            <VehicleDropdownForTrip
                              label="Vehicle Number"
                              fetchData={fetchVehicle}
                              selectedItem={formLabelValue?.vehicle_id}
                              onChange={(data) => {
                                vehicleStatusCheck(data);
                                setOwnerShip(data?.vehicle_ownership);
                              }}
                              error={!!formError.vehicle_id}
                              errorMessage={formError.vehicle_id}
                              isAddButton={true}
                              addButtonAction={(e) => addVehicleHandle(e)}
                              pageSize={7}
                              refreshTrigger={refreshVehicleDropdown}
                            />
                          </div>

                          <div
                            className="_divForth"
                            onClick={() => setVehicleTypeShow(true)}
                          >
                            <CustomSelect

                              label="Vehicle Type"
                              placeholder="Select Vehicle Type"
                              options={[
                                { label: "Vehicle Number", value: "123" },
                              ]}
                              value={vehicleTypeLabel}
                              openList={false}
                              error={formError.vehicle_type_id}
                            />
                          </div>

                          {ownerShip == 2 && (
                            <div className="_divForth">
                              <CustomSelect
                                label="Supplier name"
                                placeholder="Select Supplier"
                                options={
                                  supplierList
                                    ? supplierList
                                    : [{ label: "Select ", value: "123" }]
                                }
                                onSelect={(data) => {
                                  handleOnChange("supplier_id", data);
                                  setFormLabelValue({
                                    ...formLabelValue,
                                    supplier_id: data,
                                  });
                                }}
                                value={formLabelValue?.supplier_id}
                                isAddButton={true}
                                addButtonAction={addSupplierHandle}
                                error={formError.supplier_id}
                              />
                            </div>
                          )}

                          {/* {(ownerShip == 1 || ownerShip == 3) && ( */}
                          {(ownerShip == 1 || ownerShip == 3 || (ownerShip == 2 && formLabelValue.branch_id?.market_drive_on_dispatch?.view == 1)) && (

                            <div className="_divForth">
                              <CustomSelect

                                label="Driver"
                                placeholder="Select Driver"
                                options={
                                  driverList
                                    ? driverList.filter((i) =>
                                      ownerShip === 2 ? i?.driver_type === 2 : i?.driver_type === 1
                                    )
                                    : [{ label: "Select", value: "123" }]
                                }
                                onSelect={(data) => {
                                  handleOnChange("driver_id", data);
                                  setFormLabelValue({
                                    ...formLabelValue,
                                    driver_id: data,
                                  });
                                }}
                                value={formLabelValue?.driver_id}
                                isAddButton={true}
                                addButtonAction={addDriverHandle}
                                error={formError.driver_id}
                              />
                            </div>
                          )}

                          {/* {(formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight.view == 1 && ownerShip == 2) && <div className="_divForth"><CommonInput
                            type="text"
                            placeholder="Total Freight (₹)"
                            label="Total Freight (₹)"
                            name='total_Freight'
                            maxLength="15"
                            onInput={maxLengthCheck}

                            value={formValue.total_Freight}
                            focus={!!(typeof formError === "object" && formError?.total_Freight)}
                            error={!!(typeof formError === "object") ? formError?.total_Freight : ""}
                            onChange={({ target: { name, value } }) => {
                              if (/^\d*$/.test(value)) {
                                handleOnChange(name, value);
                                // setPhoneError("");
                              }
                            }}
                          /></div>} */}

                        </div>
                      </div>
                      {(branchView && ownerShip == 2) && <div className="">
                        <div className="__suplier_freight">
                          <h4 className="_disPatch_heads" style={{ marginBottom: '0px' }}>Supplier Freight</h4>
                          {/* <div class="dropdown-container_trip">
                          <select class="dropdown_trip">
                            <option>Fixed</option>
                            <option>Scrollable</option>
                            <option>Relative</option>
                          </select>
                        </div> */}
                          <div className="xs_size" style={{ flex: '0 0 calc(100% - 125px)' }}>
                            <CustomSelect
                              options={freightTypeList}
                              placeholder={"Freight"}
                              onSelect={(data) => handleFreightOnChange("freight_type", data.value)}
                              value={formTotal.freight_type ? freightTypeList?.find((i) => i?.value === formTotal?.freight_type) : { label: "", value: "" }}
                            />
                          </div>
                        </div>

                        <div className="_fleX_inds">

                          {formTotal.freight_type !== 6 && <div className="_divForth" style={{ display: 'flex', gap: '10px' }}>
                            <div className="clmDual_fx">
                              <CommonInput
                                type="text"
                                name="qty"
                                value={formTotal.qty}
                                onChange={({ target: { name, value } }) => {
                                  if (/^\d*$/.test(value)) {
                                    handleFreightOnChange(name, value);
                                    // setPhoneError("");
                                  }
                                }}
                                label={
                                  freightTypeList.length
                                    ? freightTypeList?.find(
                                      (i) => i?.value === formTotal?.freight_type
                                    ).label
                                    : "Qty"
                                }

                                focus={!!formError?.qty}
                                error={formError.qty}
                                maxLength={4}
                              />
                            </div>
                            <div className="clmDual_fx">
                              <CommonInput
                                type="text"
                                label="Rate"
                                name="rate"
                                value={formTotal.rate}
                                onChange={({ target: { name, value } }) => {
                                  if (/^\d*$/.test(value)) {
                                    handleFreightOnChange(name, value);
                                    // setPhoneError("");
                                  }
                                }}
                                focus={!!formError?.rate}
                                error={formError.rate}
                                maxLength={4}
                              />
                            </div>
                          </div>}
                          <div className="_divForth">
                            <CommonInput
                              type="text"
                              onChange={({ target: { name, value } }) => {
                                if (/^\d*$/.test(value)) {
                                  handleFreightOnChange(name, value);
                                  // setPhoneError("");
                                }
                              }}
                              label={
                                "Total Freight"
                              }
                              placeholder="Enter Freight"
                              value={formTotal?.amount}
                              name="amount"
                              disabled={formTotal?.freight_type !== 6}
                              focus={!!formError?.amount}
                              error={formError.amount}
                              maxLength={7}
                            />
                          </div>
                          <div className="_divForth"><CustomSelect
                            label="TDS Deduction %"
                            // value={formTotalName?.tds_diduction }
                            value={
                              tdsList?.find(
                                (i) => i?.value === formTotal?.tds_diduction
                              )

                            }
                            options={tdsList}
                            // disabled={!tdsChecked}
                            onSelect={(data) => {
                              handleFreightOnChange("tds_diduction", data?.value);
                              // setFormTotalName({ ...formTotalName, tds_diduction: data });
                            }}
                            focus={!!formError?.tds_diduction}
                            error={formError.tds_diduction}
                          />
                          </div>
                        </div>
                      </div>}
                      <div className="mb-3">
                        {vehicleStatus?.manage_trip_kms !== undefined &&
                          vehicleStatus?.manage_trip_kms != 0 && (
                            <h4 className="_disPatch_heads">
                              Truck Running Details
                            </h4>
                          )
                        }
                        {vehicleStatus?.manage_trip_kms !== undefined &&
                          vehicleStatus?.manage_trip_kms != 0 && (
                            <div className="_fleX_inds">
                              <div className="_divForth">
                                <CommonInput
                                  type="text"
                                  label="Start Kms"
                                  name="start_kms"
                                  onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                  }
                                  value={formValue?.start_kms}
                                  onKeyDown={handleKeyDown}
                                  error={formError.start_kms}
                                />
                                <p className="_bottomPLine pt-1">
                                  Last Odometer Reading{" "}
                                  <span>
                                    {lastReading
                                      ? `${lastReading} km`
                                      : "Not Found"}
                                  </span>
                                </p>
                              </div>

                              {/* <div className="_divForth">
                            <CommonInput
                              type="text"
                              label="End Kms"
                              name="end_kms"
                              onChange={({ target: { name, value } }) =>
                                handleOnChange(name, value)
                              }
                              value={formValue?.end_kms}
                              onKeyDown={handleKeyDown}
                            />
                          </div> */}

                              {/* <div className="_divForth">
                            <CommonInput
                              label="Total Kms"
                              disabled
                              value={
                                formValue.start_kms && formValue.end_kms
                                  ? parseInt(formValue.end_kms) -
                                    parseInt(formValue.start_kms)
                                  : 0
                              }
                            />
                          </div> */}
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid _verLine_cts">
                <div className="row _btmRow_cts">
                  {/* <h4 className="_disPatch_heads">
                         Locations And Lr Details
                        </h4> */}
                  {fromLoction?.map((data, index1) => {
                    return (
                      <div
                        className="col-md-12 col-lg-10 col-xl-10"
                        key={`fromLoction_${index1}`}
                      >
                        <div className="_addRouts_flex">
                          <div className="_cityInput_bx">
                            {/* <CustomSelect
                              label="From City"
                              component_class="vehicle_number_trip"
                              options={cities}
                              optionShowCityState={true}
                              dynamicIndex={index1}
                              onSelect={handleInputChange}
                              value={{
                                label: data?.from_city
                                  ? `${data?.from_city}, ${data?.from_state}`
                                  : "",
                                value: `${data?.from_city}`,
                              }}
                              error={
                                `${formError[`fromLoction[${index1}].from_city`]
                                  }` !== "undefined"
                                  ? `${formError[
                                  `fromLoction[${index1}].from_city`
                                  ]
                                  }`
                                  : ""
                              }
                            /> */}
                            <CityDropdownForTrip
                              key={`fromLoction_${index1}`}
                              label="From City * "

                              placeholder="Select a city"
                              fetchData={fetchFromCity}
                              isAddButton={true}
                              addButtonAction={(e) => addNewItemHandler(e, "from", index1, "")}
                              pageSize={20}
                              onChange={(data) => handleInputChange(data, index1, "From City", "")}
                              selectedItem={{
                                label: data?.from_city
                                  ? `${data?.from_city}, ${data?.from_state}`
                                  : "",
                                name: data?.from_city
                                  ? `${data?.from_city}`
                                  : "",
                                _id: `${data?.from_city}`,
                              }}
                              error={
                                `${formError[`fromLoction[${index1}].from_city`]
                                  }` !== "undefined"
                                  ? `${formError[
                                  `fromLoction[${index1}].from_city`
                                  ]
                                  }`
                                  : ""
                              }
                              errorMessage={
                                `${formError[`fromLoction[${index1}].from_city`]
                                  }` !== "undefined"
                                  ? `${formError[
                                  `fromLoction[${index1}].from_city`
                                  ]
                                  }`
                                  : ""
                              }
                            />

                          </div>

                          <div className="_addDel_bx">
                            {!fromLoction[index1]?.from_city ? (
                              <button
                                className="_pickN_dropBtn"
                              // onClick={addFromInput}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                >
                                  <path
                                    d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                                    fill="#1956F6"
                                  />
                                </svg>{" "}
                                <span>Add Pickup</span>
                              </button>
                            ) : (
                              <button
                                className="_pickN_dropBtn"
                                onClick={addFromInput}
                                disabled={fromLoction.some(
                                  (item) => item.from_city == ""
                                )}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                >
                                  <path
                                    d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                                    fill="#1956F6"
                                  />
                                </svg>{" "}
                                <span>Add Pickup</span>
                              </button>
                            )}
                            {fromLoction?.length > 1 && (
                              <button
                                className="_deleteBtn"
                                onClick={() => removeFromInput(index1)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                >
                                  <path
                                    d="M2.83333 17C2.31389 17 1.86937 16.8152 1.49978 16.4456C1.13019 16.076 0.945074 15.6312 0.944444 15.1111V2.83333H0V0.944444H4.72222V0H10.3889V0.944444H15.1111V2.83333H14.1667V15.1111C14.1667 15.6306 13.9819 16.0754 13.6123 16.4456C13.2427 16.8158 12.7979 17.0006 12.2778 17H2.83333ZM12.2778 2.83333H2.83333V15.1111H12.2778V2.83333ZM4.72222 13.2222H6.61111V4.72222H4.72222V13.2222ZM8.5 13.2222H10.3889V4.72222H8.5V13.2222Z"
                                    fill="#C41F1F"
                                  />
                                </svg>
                                <span>Delete</span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {Array.from({ length: divCount }, (_, index) => (
                    <>
                      {toLoction?.map((data, index1) => {
                        if (index1 === index) {
                          return (
                            <div
                              className="col-md-12 col-lg-10 col-xl-10"
                              key={`table#${index}`}
                            >
                              <div className="_addRouts_flex">
                                <div className="_cityInput_bx">
                                  {/* <CommonInput value="Jabalpur" /> */}
                                  {/* <CustomSelect
                                    label="To City"
                                    component_class="vehicle_number_trip"
                                    options={cities}
                                    optionShowCityState={true}
                                    dynamicIndex={index1}
                                    tableIndex={index}
                                    onSelect={handleInputChange}
                                    value={{
                                      label: data?.to_city
                                        ? `${data?.to_city}, ${data?.to_state}`
                                        : "",
                                      value: `${data?.to_city}`,
                                    }}
                                    // error={formError?.toLoction?.to_city}
                                    error={
                                      `${formError[
                                        `toLoction[${index1}].to_city`
                                      ]
                                        }` !== "undefined"
                                        ? `${formError[
                                        `toLoction[${index1}].to_city`
                                        ]
                                        }`
                                        : ""
                                    }
                                  /> */}

                                  <CityDropdownForTrip
                                    key={`toLoction_${index1}`}
                                    label="To City * "
                                    placeholder="Select a city"
                                    fetchData={fetchFromCity}
                                    isAddButton={true}
                                    addButtonAction={(e) => addNewItemHandler(e, "to", index1, index)}
                                    onChange={(data) => handleInputChange(data, index1, "To City", index)}
                                    selectedItem={{
                                      label: data?.to_city
                                        ? `${data?.to_city}, ${data?.to_state}`
                                        : "",
                                      name: data?.to_city
                                        ? `${data?.to_city}`
                                        : "",
                                      _id: `${data?.to_city}`,
                                    }}
                                    error={
                                      `${formError[
                                        `toLoction[${index1}].to_city`
                                      ]
                                        }` !== "undefined"
                                        ? `${formError[
                                        `toLoction[${index1}].to_city`
                                        ]
                                        }`
                                        : ""
                                    }
                                    errorMessage={
                                      `${formError[
                                        `toLoction[${index1}].to_city`
                                      ]
                                        }` !== "undefined"
                                        ? `${formError[
                                        `toLoction[${index1}].to_city`
                                        ]
                                        }`
                                        : ""
                                    }
                                  />
                                </div>

                                <div className="_addDel_bx">
                                  {!toLoction[index]?.to_city ? (
                                    <button
                                      className="_pickN_dropBtn"
                                    // onClick={addToInput}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                      >
                                        <path
                                          d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                                          fill="#1956F6"
                                        />
                                      </svg>{" "}
                                      <span>Add Drop</span>
                                    </button>
                                  ) : (
                                    <button
                                      className="_pickN_dropBtn"
                                      onClick={addToInput}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                      >
                                        <path
                                          d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                                          fill="#1956F6"
                                        />
                                      </svg>{" "}
                                      <span>Add Drop</span>
                                    </button>
                                  )}

                                  {toLoction?.length > 1 && (
                                    <button
                                      className="_deleteBtn"
                                      onClick={() => removeDiv(index, toLoction[index]?.to_city, toLoction[index]?.to_state)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="17"
                                        viewBox="0 0 16 17"
                                        fill="none"
                                      >
                                        <path
                                          d="M2.83333 17C2.31389 17 1.86937 16.8152 1.49978 16.4456C1.13019 16.076 0.945074 15.6312 0.944444 15.1111V2.83333H0V0.944444H4.72222V0H10.3889V0.944444H15.1111V2.83333H14.1667V15.1111C14.1667 15.6306 13.9819 16.0754 13.6123 16.4456C13.2427 16.8158 12.7979 17.0006 12.2778 17H2.83333ZM12.2778 2.83333H2.83333V15.1111H12.2778V2.83333ZM4.72222 13.2222H6.61111V4.72222H4.72222V13.2222ZM8.5 13.2222H10.3889V4.72222H8.5V13.2222Z"
                                          fill="#C41F1F"
                                        />
                                      </svg>
                                      <span>Delete</span>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                      <div className="col-md-12 col-lg-10 col-xl-10">
                        <div className="_spaceTble">
                          {tripTable?.map((data, index3) => {

                            return (
                              <div
                                className="accordionTable_view"
                                key={`TripTable_${index3}`}
                              >
                                <div
                                  className="accordion"
                                  id="accordionExample2"
                                >
                                  {index === index3 &&
                                    newListOfLr[index3]?.list?.length ? (
                                    <>
                                      {newListOfLr[index3]?.list &&
                                        newListOfLr[index3]?.list?.length
                                        ? newListOfLr[index3]?.list?.map(
                                          (i, index1) => {

                                            return (
                                              <div
                                                className="accordion-item"
                                                key={`TripTable_${index3}${index1}`}
                                              >
                                                <h2 className="accordion-header">
                                                  <div className="PickNdrop_placeBx">
                                                    <div
                                                      className="_inrPd"
                                                      bis_skin_checked="1"
                                                    >
                                                      <h4>
                                                        {i?.from_location}
                                                      </h4>
                                                      <img
                                                        src={
                                                          Images.ROUTTRUCKICON
                                                            .default
                                                        }
                                                        alt=""
                                                      />
                                                      <h4>
                                                        {i?.to_location}
                                                      </h4>
                                                      <button
                                                        className={`accordion-button collapsed`}
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse${index1}${index3}`}
                                                        aria-expanded="true"
                                                        aria-controls={`collapse${index1}${index3}`}
                                                      >
                                                        <svg
                                                          className="cstCevs"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="18"
                                                          height="18"
                                                          viewBox="0 0 18 18"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M4.91862 6.69936C4.87178 6.6502 4.81668 6.61176 4.75647 6.58625C4.69625 6.56074 4.63211 6.54865 4.56769 6.55068C4.50327 6.5527 4.43984 6.5688 4.38102 6.59805C4.3222 6.6273 4.26915 6.66913 4.22488 6.72116C4.18062 6.77319 4.14602 6.83439 4.12305 6.90127C4.10008 6.96815 4.08919 7.0394 4.09102 7.11095C4.09284 7.18251 4.10733 7.25296 4.13367 7.31829C4.16 7.38362 4.19767 7.44255 4.24451 7.49172L8.6601 12.1238C8.75119 12.2194 8.87179 12.2727 8.99715 12.2727C9.12251 12.2727 9.24312 12.2194 9.33421 12.1238L13.7503 7.49172C13.7982 7.44288 13.8368 7.38396 13.864 7.31839C13.8912 7.25282 13.9064 7.1819 13.9087 7.10975C13.911 7.0376 13.9004 6.96566 13.8774 6.89811C13.8545 6.83056 13.8197 6.76875 13.7751 6.71626C13.7305 6.66377 13.6769 6.62165 13.6175 6.59235C13.5581 6.56305 13.494 6.54715 13.4291 6.54558C13.3641 6.54401 13.2995 6.5568 13.239 6.5832C13.1785 6.60959 13.1233 6.64908 13.0767 6.69936L8.99715 10.9783L4.91862 6.69936Z"
                                                            fill="#1450EC"
                                                          />
                                                          <circle
                                                            cx="9"
                                                            cy="9"
                                                            r="8.59091"
                                                            transform="rotate(-180 9 9)"
                                                            stroke="#0049D7"
                                                            strokeWidth="0.818182"
                                                          />
                                                        </svg>
                                                      </button>
                                                    </div>
                                                    <div className="_pdTransport_dl">
                                                      <h5>
                                                        {
                                                          i?.consignor_id
                                                            ?.name
                                                        }
                                                      </h5>
                                                      <span
                                                        className="_avPointer"
                                                        onClick={(e) =>
                                                          handleDetailsAction(
                                                            i
                                                          )
                                                        }
                                                      >
                                                        {i?.invoice_number
                                                          ? `INV- ${i?.invoice_number}`
                                                          : ""}
                                                      </span>
                                                      <span
                                                        className="_avPointer"
                                                        onClick={(e) =>
                                                          handleDetailsAction(
                                                            i
                                                          )
                                                        }
                                                      >
                                                        {i?.lr_number
                                                          ? `# ${i?.lr_number}`
                                                          : ""}
                                                      </span>
                                                      {i?._id && <span
                                                        className="_avPointer"
                                                        onClick={(e) =>
                                                          handleDetailsAction(
                                                            i
                                                          )
                                                        }
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="17"
                                                          height="17"
                                                          viewBox="0 0 17 17"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M3.64706 4.52942H2.76471C2.29668 4.52942 1.84782 4.71534 1.51687 5.04629C1.18592 5.37724 1 5.8261 1 6.29413V14.2353C1 14.7033 1.18592 15.1522 1.51687 15.4831C1.84782 15.8141 2.29668 16 2.76471 16H10.7059C11.1739 16 11.6228 15.8141 11.9537 15.4831C12.2847 15.1522 12.4706 14.7033 12.4706 14.2353V13.353"
                                                            stroke="#0049D7"
                                                            strokeWidth="1.76469"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                          />
                                                          <path
                                                            d="M11.5881 2.7648L14.2352 5.41186M15.4572 4.16333C15.8047 3.81582 16 3.34449 16 2.85304C16 2.36158 15.8047 1.89025 15.4572 1.54274C15.1097 1.19523 14.6384 1 14.1469 1C13.6555 1 13.1841 1.19523 12.8366 1.54274L5.41162 8.94128V11.5883H8.05868L15.4572 4.16333Z"
                                                            stroke="#0049D7"
                                                            strokeWidth="1.76469"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                          />
                                                        </svg>
                                                      </span>}
                                                    </div>
                                                  </div>
                                                  {!i?.plan_id?._id && <button
                                                    className="closeTble_btn"
                                                    type="button"
                                                    onClick={(e) => {
                                                      handleDelteSubmit(
                                                        i,
                                                        index1,
                                                        index3
                                                      );
                                                    }}
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="56"
                                                      height="29"
                                                      viewBox="0 0 56 29"
                                                      fill="none"
                                                    >
                                                      <rect
                                                        x="56"
                                                        y="29"
                                                        width="56"
                                                        height="29"
                                                        rx="14.5"
                                                        transform="rotate(180 56 29)"
                                                        fill="#434343"
                                                      />
                                                      <path
                                                        d="M41.9806 10.2104C41.9162 10.1458 41.8396 10.0946 41.7554 10.0596C41.6711 10.0247 41.5807 10.0067 41.4895 10.0067C41.3983 10.0067 41.3079 10.0247 41.2237 10.0596C41.1394 10.0946 41.0629 10.1458 40.9984 10.2104L37.592 13.6098L34.1856 10.2034C34.1211 10.1389 34.0446 10.0878 33.9603 10.0529C33.876 10.018 33.7857 10 33.6945 10C33.6033 10 33.513 10.018 33.4287 10.0529C33.3445 10.0878 33.2679 10.1389 33.2034 10.2034C33.1389 10.2679 33.0878 10.3445 33.0529 10.4287C33.018 10.513 33 10.6033 33 10.6945C33 10.7857 33.018 10.876 33.0529 10.9603C33.0878 11.0446 33.1389 11.1211 33.2034 11.1856L36.6098 14.592L33.2034 17.9984C33.1389 18.0629 33.0878 18.1395 33.0529 18.2237C33.018 18.308 33 18.3983 33 18.4895C33 18.5807 33.018 18.671 33.0529 18.7553C33.0878 18.8396 33.1389 18.9161 33.2034 18.9806C33.2679 19.0451 33.3445 19.0963 33.4287 19.1312C33.513 19.1661 33.6033 19.184 33.6945 19.184C33.7857 19.184 33.876 19.1661 33.9603 19.1312C34.0446 19.0963 34.1211 19.0451 34.1856 18.9806L37.592 15.5742L40.9984 18.9806C41.0629 19.0451 41.1395 19.0963 41.2237 19.1312C41.308 19.1661 41.3983 19.184 41.4895 19.184C41.5807 19.184 41.671 19.1661 41.7553 19.1312C41.8396 19.0963 41.9161 19.0451 41.9806 18.9806C42.0451 18.9161 42.0963 18.8396 42.1312 18.7553C42.1661 18.671 42.184 18.5807 42.184 18.4895C42.184 18.3983 42.1661 18.308 42.1312 18.2237C42.0963 18.1395 42.0451 18.0629 41.9806 17.9984L38.5742 14.592L41.9806 11.1856C42.2453 10.9209 42.2453 10.4751 41.9806 10.2104Z"
                                                        fill="white"
                                                      />
                                                    </svg>
                                                  </button>}
                                                </h2>

                                                <div
                                                  id={`collapse${index1}${index3}`}
                                                  className="accordion-collapse collapse"
                                                  data-bs-parent="#accordionExample2"
                                                >
                                                  <div className="accordion-body">
                                                    <table className="ctmTable">
                                                      <thead>
                                                        <tr className="accordiTr">
                                                          <th>Date</th>
                                                          <th>
                                                            From Station
                                                          </th>
                                                          <th>To Station</th>
                                                          <th>
                                                            Invoice Number
                                                          </th>
                                                          <th>Qty</th>
                                                          <th>Weight</th>
                                                          <th>KOT</th>
                                                          <th>Eway Bill</th>
                                                          <th>Expiry Date</th>
                                                        </tr>
                                                      </thead>

                                                      <tbody>
                                                        <tr>
                                                          <td>
                                                            <span>
                                                              {" "}
                                                              {moment(
                                                                i?.indent_date
                                                              ).format(
                                                                " D  MMM YYYY"
                                                              )}
                                                            </span>
                                                            <br />
                                                            <span className="sameSpan">
                                                              5:30 PM
                                                            </span>
                                                          </td>

                                                          <td>
                                                            <span className="sameSpan fw-500">
                                                              {
                                                                i?.from_location
                                                              }
                                                            </span>
                                                            <br />
                                                            <span className="sameSpan">
                                                              {i?.unit_id
                                                                ?.code
                                                                ? i?.unit_id
                                                                  ?.code
                                                                : " -"}{" "}
                                                              {i?.unit_id
                                                                ?.code && i?.unit_id
                                                                  ?.name ? " | " : ""}
                                                              {i?.unit_id
                                                                ?.name
                                                                ? i?.unit_id
                                                                  ?.name
                                                                : " -"}
                                                            </span>
                                                            <br />
                                                            <span className="sameSpan fw-400">
                                                              {i?.unit_id?.zone_id?.name ? `Zone - ${i?.unit_id?.zone_id?.name}` : ""}
                                                            </span>
                                                          </td>

                                                          <td>
                                                            <span className="sameSpan fw-500">
                                                              {i?.to_location}
                                                            </span>
                                                            <br />
                                                            <span className="sameSpan">
                                                              {i?.consignee_id
                                                                ?.code
                                                                ? i
                                                                  ?.consignee_id
                                                                  ?.code
                                                                : " -"}{" "}
                                                              |{" "}
                                                              {i?.consignee_id
                                                                ?.name
                                                                ? i
                                                                  ?.consignee_id
                                                                  ?.name
                                                                : "-"}
                                                            </span>
                                                            <br />
                                                            <span className="sameSpan fw-400">
                                                              {i?.consignee_id?.zone_id?.name ? `Zone - ${i?.consignee_id?.zone_id?.name}` : ""}
                                                            </span>
                                                          </td>

                                                          <td>
                                                            <span
                                                              className="_invoicSpan"
                                                              style={{ cursor: "pointer" }}
                                                              onClick={(e) =>
                                                                i?.invoice_number
                                                                  ? handleDetailsAction(
                                                                    i
                                                                  )
                                                                  : ""
                                                              }
                                                            >
                                                              {i?.invoice_number
                                                                ? i?.invoice_number
                                                                : "-"}
                                                            </span>
                                                            <br />
                                                            <span className="sameSpan">
                                                              {i?.po_number
                                                                ? i?.po_number
                                                                : "-"}
                                                            </span>
                                                          </td>

                                                          <td>
                                                            <span className="sameSpan">
                                                              {i?.total_qty}
                                                            </span>
                                                          </td>

                                                          <td>
                                                            <span className="sameSpan">
                                                              {
                                                                i?.total_weight
                                                              }
                                                            </span>
                                                          </td>

                                                          <td>
                                                            <span className="sameSpan">
                                                              {i?.total_kot}
                                                            </span>
                                                          </td>

                                                          <td>
                                                            <span
                                                              className="sameSpan"
                                                              onClick={() =>
                                                                ewayBillHandle(
                                                                  i
                                                                )
                                                              }
                                                            >
                                                              {i?.eway_bill_number ? (
                                                                i?.eway_bill_number
                                                              ) : (
                                                                <span
                                                                  className="_avPointer _invoicSpan"
                                                                  onClick={() =>
                                                                    ewayBillHandle(
                                                                      i
                                                                    )
                                                                  }
                                                                >
                                                                  + Add Eway
                                                                  Bill
                                                                </span>
                                                              )}
                                                            </span>
                                                          </td>

                                                          <td>
                                                            <span className="sameSpan">
                                                              {i?.eway_bill_number
                                                                ? moment(
                                                                  i?.indent_date
                                                                ).format(
                                                                  " D  MMM YYYY"
                                                                )
                                                                : ""}
                                                            </span>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          }
                                        )
                                        : ""}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        <div className="lrDeatilsTrip _spaceTble">
                          <button
                            className="_addComm_btn"
                            type="button"

                            onClick={() => {
                              setIndexofTable(index);
                              addTable();

                              setTimeout(() => setSelectParty(true), 0);
                            }}
                          >
                            Add New LR
                          </button>
                          <button
                            className="_addComm_btn"
                            type="button"
                            // disabled={!toLoction[index]?.to_city}
                            onClick={() => {
                              addTable();
                              setIndexofTable(index);
                              setShowSelectLr(true);
                            }}
                          >
                            Add Existing LR
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>


              {formLabelValue?.branch_id?.loading_challi?.view == 1 && <div className="container-fluid pt-5">
                <h4 className="_disPatch_heads mb-2">Loading Challi</h4> <LoadingChalli values={challiValues}
                  onChange={handleChalliChange} mandatory={formLabelValue?.branch_id?.loading_challi?.mandatory} /></div>}
              {!!formError.loadingChalli && (
                <div style={{ color: "red", fontSize: 12, marginTop: 4, fontWeight: 500 }}>
                  {formError.loadingChalli}
                </div>
              )}

            </div>
          </div>

          <div className="bottomFix">
            <button
              onClick={() => onValidationCheck()}
              className="_addComm_btn"
              type="button"
            // disabled={
            //   !formValue.branch_id ||
            //   !formValue.vehicle_type_id ||
            //   !formValue.vehicle_id ||
            //   !formValue.dispatch_date ||
            //   !fromLoction.every((location) => location.from_city) ||
            //   !toLoction.every((location) => location.to_city) ||
            //   allFrightLr.length === 0 ||
            //   !(ownerShip == 1
            //     ? formValue?.driver_id
            //     : formValue?.supplier_id)
            // }
            >
              Dispatch Trip{" "}
            </button>

            {/* <button className="_cancel_btn">Cancel</button> */}
          </div>

          {show && <LrFreightModal {...firstAddLrModal} />}

          {showCreatRoute && <AddRouteModal {...firstCreateRouteModal} />}
          {showSelectLr && <SelectLrModal {...selectLrModalProps} />}
          {confirmModalShow && (
            <ConfirmModalFor {...confirmModalProps}>
              <>
                <p className="_confirmPrx">
                  {" "}
                  Are you sure you want to delete " {LrDetele.title} "{" "}
                </p>
              </>
            </ConfirmModalFor>
          )}
          {ewaybillShow && (
            <ConfirmModalFor {...ewaybillprops}>
              <>
                <div className="colFlx">
                  <div className="_addRouts_flex">
                    <CommonDatePicker
                      name="dispatch_date"
                      label="Date of Dispatch"
                      startDate={ewayForm?.start_date}
                      setStartDate={(data) => {
                        handleChange("start_date", data);
                      }}
                      error={formError?.start_date}
                      focus={formError?.start_date}
                    />
                    <CommonDatePicker
                      name="dispatch_date"
                      label="Date of Dispatch"
                      startDate={ewayForm?.end_date}
                      setStartDate={(data) => {
                        handleChange("end_date", data);
                      }}
                      error={formError?.end_date}
                      focus={formError?.end_date}
                    />
                  </div>
                  <CommonInput
                    label="Eway bill number"
                    placeholder="Enter Number"
                    name="eway_bill_number"
                    onChange={({ target: { name, value } }) =>
                      handleChange(name, value)
                    }
                    maxLength={12}
                    value={ewayForm?.eway_bill_number}
                    onKeyDown={handleKeyDown}
                    error={formError?.eway_bill_number}
                    focus={formError?.eway_bill_number}
                  />
                </div>
              </>
            </ConfirmModalFor>
          )}
          {vehicleTypeshow && <VehicleTypeModal {...vehicleTypeProps} />}

          <div
            className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
              }`}
            tabIndex={-1}
            style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
          >
            {showOffcanvas && (
              <AddEditVehicleModal
                isOpen={showOffcanvas}
                onClose={() => setShowOffcanvas(false)}
                callBackVehicle={callBackVehicle}
                isSupplier={isSupplier}
                isDriver={isDriver}
                handleAddNewSupplierButtonAction={
                  handleAddNewSupplierButtonAction
                }
                handleAddNewVehicleButtonAction={
                  handleAddNewVehicleButtonAction
                }
                hideAddNewOption={false}
              />
            )}
          </div>

          <div className={showOffcanvas ? "offBack_drop" : ""}></div>

          {/* Supplier Canvas Open and Vahicle canvas will close */}
          <div
            className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfSupplier ? "show" : ""
              }`}
            tabIndex={-1}
            style={{
              visibility: showOffcanvasOfSupplier ? "visible" : "hidden",
            }}
          >
            {showOffcanvasOfSupplier && (
              <AddEditSupplier
                isOpen={showOffcanvasOfSupplier}
                onClose={(e) => setShowOffcanvasOfSupplier(false)}
                callBackSupplier={(e) => handleSupplierNextModal(e)}
                hideAddNewOption={false}
              />
            )}
          </div>
          <div className={showOffcanvasOfSupplier ? "offBack_drop" : ""}></div>

          {/* Driver Canvas Open and Vahicle canvas will close */}
          <div
            className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfDriver ? "show" : ""
              }`}
            tabIndex={-1}
            style={{ visibility: showOffcanvasOfDriver ? "visible" : "hidden" }}
          >
            {showOffcanvasOfDriver && (
              <AddEditOwnDriver
                isOpen={showOffcanvasOfDriver}
                onClose={() => setShowOffcanvasOfDriver(false)}
                callBackDriver={(e) => handleDriverNextModal(e)}
                hideAddNewOption={false}
                // vehicleFirmId={driverFirmId}
              />
            )}
          </div>
          <div className={showOffcanvasOfDriver ? "offBack_drop" : ""}></div>

          <div
            className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasSupplier ? "show" : ""
              }`}
            tabIndex={-1}
            style={{ visibility: showOffcanvasSupplier ? "visible" : "hidden" }}
          >
            {showOffcanvasSupplier && (
              <AddEditSupplier
                isOpen={showOffcanvasSupplier}
                onClose={() => setShowOffcanvasSupplier(false)}
                callBackSupplier={callBackSupplier}
                hideAddNewOption={false}
              />
            )}
          </div>
          <div className={showOffcanvasSupplier ? "offBack_drop" : ""}></div>
          <div
            className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasDriver ? "show" : ""
              }`}
            tabIndex={-1}
            style={{ visibility: showOffcanvasDriver ? "visible" : "hidden" }}
          >
            {showOffcanvasDriver && (
              <AddEditOwnDriver
                isOpen={showOffcanvasDriver}
                onClose={(e) => setShowOffcanvasDriver(false)}
                callBackDriver={callBackDriver}
              />
            )}
          </div>
          <div className={showOffcanvasDriver ? "offBack_drop" : ""}></div>
          <div
            className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasMarketDriver ? "show" : ""
              }`}
            tabIndex={-1}
            style={{ visibility: showOffcanvasMarketDriver ? "visible" : "hidden" }}
          >
            {showOffcanvasMarketDriver && (
              <AddEditMarketDriver
                isOpen={showOffcanvasMarketDriver}
                onClose={(e) => setShowOffcanvasMarketDriver(false)}
                callBackDriver={callBackDriver}
                hideAddNewOption={false}
              />
            )}
          </div>

          <div className={showOffcanvasMarketDriver ? "offBack_drop" : ""}></div>

          <div
            className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showLrDetail ? "show" : ""
              }`}
            tabIndex={-1}
            style={{ visibility: showLrDetail ? "visible" : "hidden" }}
          >
            {showLrDetail && (
              <LrDetailModal
                isOpen={showLrDetail}
                onClose={(e) => setShowLrDetail(false)}
                nextModal={(e) => handleNextModal(e)}
                createTripBtn={true}

              />
            )}
          </div>
          <div className={showLrDetail ? "offBack_drop" : ""}></div>

          {selectParty && <AddLrModal {...selectPartyModal} />}

          <div
            className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showAddLR ? "show" : ""
              }`}
            tabIndex={-1}
            style={{ visibility: showAddLR ? "visible" : "hidden" }}
          >
            {showAddLR && (
              <AddEditLrModal
                isOpen={showAddLR}
                onClose={() => setShowAddLR(false)}
                callBackDataLr={callBackDataLr}
                type="from_trip"
                callGetData={() => { }}
              />
            )}
          </div>
          <div className={showAddLR ? "offBack_drop" : ""}></div>

          {showEndTrip && <EndTripModal {...endTripModal} />}

          {showAvailableTruck && (
            <MakeTruckAvailableModal {...makeTruckModal} />
          )}
        </>
      ) : (
        <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}> <Loading /></div>

      )}

      <input ref={hiddenInputRef} type="hidden" />
      {showBackModal && (
        <ConfirmModalFor {...backModalProps}>
          <>
            <p className="_confirmPrx"> Do you really want leave this Page ?</p>
          </>
        </ConfirmModalFor>
      )}

      {showWithOutLrModal && (
        <ConfirmModalFor {...withoutLrModalProps}>
          <>
            <p className="_confirmPrx"> Do you really want dispatch Trip without Lr ? </p>
          </>
        </ConfirmModalFor>
      )}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isAddConsignor ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: isAddConsignor ? "visible" : "hidden" }}
      >
        {isAddConsignor && (
          <AddEditConsignor
            isOpen={isAddConsignor}
            onClose={() => setIsAddConsignor(false)}
            isPreviousModal={(e) => setSelectParty(true)}
            showingPrefield={(e) => setShowingPrefield(true)}
            hideAddNewOption={false}
          />
        )}
      </div>

      <div className={isAddConsignor ? "offBack_drop" : ""}></div>

      {/* {openLoction && <AddLocationModal {...gmapLocate} />} */}

 <div
        className={`offcanvas offcanvas-end common_offCanvas ${openLoction ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: openLoction ? "visible" : "hidden" }}
      >
        {openLoction && <AddLocationModal {...gmapLocate} />}
      </div>

      <div className={openLoction ? "offBack_drop" : ""}></div>
    </>
  );
};

export default CreatTrip;




